<template>
    <div class="contentbox private">
      <div class="toptitle">
        <div class="return">
          <router-link tag="div" to="/commodity">&lt;</router-link>
        </div>
        <p>安装位置</p>
        <div>
          <span class="personalicon" @click="reopenNewOrder">
            <img src="../assets/images/add.png" alt="">
          </span>
          <span @click="inorderlist">
            <img src="../assets/images/chat.png" alt="">
          </span>
          <span class="personalicon" @click="showPersonalCenter">
            <img src="../assets/images/personal.png" alt="">
          </span>
        </div>
      </div>
      <mt-popup
        v-model="popupVisible"
        :modal="false"
        position="right">
        <slot>
          <div class="PersonalCenter">
            <h1>个人中心</h1>
            <div>公司名称({{$store.state.loginuserdata.enterprise}})</div>
            <div>用户名称({{$store.state.loginuserdata.username}})</div>
            <div><mt-button @click="curtainlogout" type="danger">退出</mt-button></div>
            <div><mt-button @click="showPersonalCenter" type="primary">返回</mt-button></div>
          </div>
        </slot>
      </mt-popup>
      <!--主产品-->
      <div class="pcbox">
        <div class="topimgbox">
          <img :src="detail.smallpic" alt="">
        </div>
        <div class="r">
          <div class="numberbox">
            <div class="title">{{detail.product_name}}</div>
            <div class="clearfloat number">
              <p class="lf">
                <span @click="productreduce" class="reduce">-</span>
                <span class="num">{{num}}</span>
                <span @click="productadd" class="add">+</span>
              </p>
              <p v-if="detail.expend_price>0" class="rg">
                {{detail.currency_symbol}} {{detail.expend_price}}
              </p>
              <p v-if="detail.expend_price<=0" class="rg">{{detail.currency_symbol}} {{minAccessories}} ~ {{detail.currency_symbol}} {{mixAccessories}}</p>
            </div>
            <div class="clearfloat">
              安裝費用：
              <span> {{detail.product_installation_charge_curr}}
             {{detail.product_installation_charge}}</span>
            </div>
            <!--组合属性-->
            <div class="combination_attributes" v-if="combinationattributes.length>1">
              <el-select @change="selectattributes"
                         v-model="attribute_group_value">
                <el-option
                  v-for="(list,index) in combinationattributes"
                  :key="index"
                  :label="list.attribute_value_group"
                  :value="index">
                </el-option>
              </el-select>
            </div>
            <!--属性-->
            <div v-if="typeof productAttribute === 'object'"
                 :key="index"
                 v-for="(itme,index) in productAttribute">
              <span class="attributename">{{itme.product_attribute_name_title}}：</span>
              <el-input style="width: 20%"
                        size="mini"
                        @blur="onSizerange"
                        @input="oninput"
                        v-if="!itme.attribute_list"
                        :data-min="itme.restriction_min"
                        :data-max="itme.restriction_max"
                        :data-attribute_id="itme.attribute_id"
                        v-model="itme.product_attribute_name"></el-input>
              <!--multiple  :multiple="itme.select_type==='2'" 多选-->
              <el-select @change="itme.select_type!=='2' && oninput()"
                         :multiple="itme.select_type==='2'"
                         :disabled="itme.disabled"
                         v-model="itme.product_attribute_name"
                         v-if="itme.attribute_list && itme.product_attribute_name_title!='顏色'">
                <el-option
                  v-for="(list) in itme.attribute_list"
                  :key="list"
                  :label="list"
                  :value="list">
                </el-option>
              </el-select>

              <el-select v-if="itme.attribute_list && itme.product_attribute_name_title=='顏色'"
                         :style="{'background': itme.product_attribute_name}"
                         class="popper-class colorclass"
                         :disabled="itme.disabled"
                         size="mini"
                         v-model="itme.product_attribute_name" placeholder="请选择">
                <el-option
                  class="selectitme"
                  :style="{'background-color': list}"
                  v-for="(list) in itme.attribute_list"
                  :key="list"
                  :value="list">
                </el-option>
              </el-select>

            </div>
          </div>
          <!--计算属性-->
          <div v-if="typeof productAttribute === 'object'" class="computedbox">
            <div @click="showcomputedbox" class="clickbox">公式：</div>
            <div :key="index"
                 v-if="itme.in_formula===1"
                 v-for="(itme,index) in productAttribute">
              <span class="attributename">{{itme.product_attribute_name_title}}：</span>
              <el-input v-if="!itme.attribute_list"
                        size="mini"
                        type="number"
                        @blur="onSizerange"
                        @input="oninput"
                        :data-min="itme.restriction_min"
                        :data-max="itme.restriction_max"
                        :data-attribute_id="itme.attribute_id"
                        v-model="itme.product_attribute_name"></el-input>
              <!--<select @change="oninput" v-if="itme.attribute_list" v-model="itme.product_attribute_name">-->
              <!--<option :key="index2" v-for="(list,index2) in itme.attribute_list">{{list}}</option>-->
              <!--</select>-->
              <el-select @change="oninput"
                         v-model="itme.product_attribute_name"
                         v-if="itme.attribute_list">
                <el-option
                  v-for="(list) in itme.attribute_list"
                  :key="list"
                  :label="list"
                  :value="list">
                </el-option>
              </el-select>
            </div>
            <div><span class="formula">公式：</span><span v-html="productCalculationFormula"></span></div>
            <div v-if="multiplesFormula"><span class="formula">倍数公式：</span><span v-html="multiplesFormula"></span></div>
            <div>結果：{{detail.result}}</div>
          </div>
        </div>
      </div>
      <div class="meassagebox">
        商品描述：<span v-html="detail.product_description"></span>
      </div>
      <div class="garnishbox">
        <!--一级配件-->
        <h1>配件</h1>
        <ul v-if="typeof productAccessories === 'object'" class="clearfloat">
          <li :class="itme.select" :key="index" v-for="(itme,index) in productAccessories">
            <img @click.capture="onselect(itme.Identification)"
                 onerror="onerror=null;src='./static/img/buf.e019189.png'"
                 :src="itme.bigImageUrl?itme.bigImageUrl:buf"/>
            <div class="titlebox">
              <p class="tltle">{{itme.product_name}}</p>
              <p v-if="itme.productAccessoriesPrice!==0">
                {{itme.currency_symbol}} {{itme.productAccessoriesPrice}}
              </p>
              <p class="selectedquantity">
                安裝費用：{{itme.product_installation_charge_curr}} {{itme.product_installation_charge}}
                <span v-if="itme.select!=='active' && itme.sun>0">x {{itme.sun}}</span>
              </p>
            </div>
            <!--属性组合-->
            <div class="attributebox give" v-if="itme.AttributeGroup && itme.select==='active'">
              组合属性：
              <el-select @change="onAccessoriesinput(itme.Identification)"
                         v-model="itme.composite_attribute_value">
                <el-option
                  v-for="(list,index) in itme.AttributeGroup"
                  :key="index"
                  :label="list.attribute_value_group"
                  :value="list.id">
                </el-option>
              </el-select>
            </div>
            <!--属性-->
           <div class="attributebox"
                v-if="typeof itme.productAttribute === 'object' && itme.select==='active'">
             <div>
               <p :key="list.product_attribute_id"
                  v-for="(list) in itme.productAttribute">
                 {{list.product_attribute_name_title}}:
                 <el-input v-if="!list.attribute_list"
                           v-model="list.product_attribute_name"
                           @blur="onattributeSizerange(itme.Identification,list.attribute_id,itme.restriction_min,itme.restriction_max)"
                           @input="onAccessoriesinput(itme.Identification,list.attribute_id)"
                           size="mini"></el-input>
                 <el-select  @change="list.select_type!=='2' && onAccessoriesinput(itme.Identification,list.attribute_id)"
                             :multiple="list.select_type==='2'"
                             v-model="list.product_attribute_name"
                             :disabled="list.disabled"
                             v-if="list.attribute_list && list.product_attribute_name_title!='顏色'">
                   <el-option
                     v-for="(listchild) in list.attribute_list"
                     :key="listchild"
                     :label="listchild"
                     :value="listchild">
                   </el-option>
                 </el-select>
                 <!--颜色-->
                 <el-select
                   v-if="list.attribute_list && list.product_attribute_name_title=='顏色'"
                   :style="{'background': list.product_attribute_name}"
                   class="popper-class"
                   size="mini"
                   v-model="list.product_attribute_name" placeholder="请选择">
                   <el-option
                     class="selectitme"
                     :style="{'background-color': listchild}"
                     v-for="(listchild,index3) in list.attribute_list"
                     :key="index3"
                     :value="listchild">
                   </el-option>
                 </el-select>
               </p>
             </div>
           </div>
            <!--计算属性-->
            <div class="attributebox"
                 v-if="typeof itme.productAttribute === 'object' && itme.select==='active'">
              <div>
                <p :key="list.attribute_id"
                   v-if="list.in_formula===1"
                   :class="indexone==0?'one':''"
                   v-for="(list,indexone) in itme.productAttribute">
                  {{list.product_attribute_name_title}}:
                  <el-input v-if="!list.attribute_list"
                            @input="onAccessoriesinput(itme.Identification,list.attribute_id)"
                            @blur="onattributeSizerange(itme.Identification,list.attribute_id)"
                            :data-min="itme.restriction_min"
                            :data-max="itme.restriction_max"
                            v-model="list.product_attribute_name"
                            type="number"
                            size="mini"></el-input>
                  <el-select  @change="onAccessoriesinput(itme.Identification,list.attribute_id)"
                              v-model="list.product_attribute_name"
                              v-if="list.attribute_list">
                    <el-option
                      v-for="(listchild) in list.attribute_list"
                      :key="listchild"
                      :label="listchild"
                      :value="listchild">
                    </el-option>
                  </el-select>
                </p>
                <p v-if="typeof itme.productAttribute === 'object'">
                  <span class="formula">公式：</span>
                  <span v-html="itme.productCalculationFormula"></span>
                </p>
                <p v-if="typeof itme.multiplesAttribute === 'object'">
                  <span class="formula">倍数公式：</span>
                  <span v-html="itme.multiplesFormula"></span>
                </p>
                <p class="towbottom" v-if="typeof itme.productAttribute === 'object'">
                  <span>结果：{{itme.result}}</span>
                </p>
              </div>
            </div>

            <!--数量选择-->
            <p v-if="itme.select==='active'" class="sunbox">
              <span @click="onreduce(itme.Identification)" class="reduce">-</span>
              <span class="num">{{itme.sun}}</span>
              <span @click="onadd(itme.Identification)" class="add">+</span>
            </p>
          </li>
        </ul>

        <!--二级配件-->
        <h1 v-if="showsparts2.length">{{showspartsname2}}</h1>
        <ul v-if="showsparts2.length" class="clearfloat childPartsData">
          <li :class="itme2.select" :key="childindex" v-for="(itme2,childindex) in showsparts2">
            <img @click.capture="onselect(itme2.Identification)"
                 onerror="onerror=null;src='./static/img/buf.e019189.png'"
                 :src="itme2.bigImageUrl?itme2.bigImageUrl:buf"/>
            <div class="titlebox">
              <p class="tltle">{{itme2.product_name}}</p>
              <p v-if="itme2.productAccessoriesPrice>0" class="productAccessoriesPrice">{{itme2.currency_symbol}} {{itme2.productAccessoriesPrice}}</p>
              <p class="selectedquantity">
                安裝費用：{{itme2.product_installation_charge_curr}} {{itme2.product_installation_charge}}
                <span v-if="itme2.select!=='active' && itme2.sun>0">x {{itme2.sun}}</span>
              </p>
            </div>
            <!--属性组合-->
            <div class="attributebox give" v-if="itme2.AttributeGroup && itme2.select==='active'">
              组合属性：
              <el-select @change="onAccessoriesinput(itme2.Identification)"
                         v-model="itme2.composite_attribute_value">
                <el-option
                  v-for="(list,index) in itme2.AttributeGroup"
                  :key="index"
                  :label="list.attribute_value_group"
                  :value="list.id">
                </el-option>
              </el-select>
            </div>
            <!--属性-->
            <div class="attributebox" v-if="typeof itme2.productAttribute === 'object' && itme2.select==='active'">
              <div>
                <p :key="list.product_attribute_id"
                   v-for="(list) in itme2.productAttribute">
                  <!--{{list.product_attribute_name_title}}：{{list.product_attribute_name}}-->
                  {{list.product_attribute_name_title}}:
                  <el-input v-if="!list.attribute_list"
                            v-model="list.product_attribute_name"
                            @blur="onattributeSizerange(itme2.Identification,list.attribute_id,list.restriction_min,list.restriction_max)"
                            @input="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                            size="mini"></el-input>
                  <el-select  @change="list.select_type!=='2' && onAccessoriesinput(itme2.Identification)"
                              :multiple="list.select_type==='2'"
                              :disabled="list.disabled"
                              v-model="list.product_attribute_name"
                              v-if="list.attribute_list && list.product_attribute_name_title!=='顏色'">
                    <el-option
                      v-for="(listchild) in list.attribute_list"
                      :key="listchild"
                      :label="listchild"
                      :value="listchild">
                    </el-option>
                  </el-select>
                  <!--颜色-->
                  <el-select
                    v-if="list.attribute_list && list.product_attribute_name_title=='顏色'"
                    :style="{'background': list.product_attribute_name}"
                    class="popper-class"
                    size="mini"
                    v-model="list.product_attribute_name" placeholder="请选择">
                    <el-option
                      class="selectitme"
                      :style="{'background-color': listchild}"
                      v-for="(listchild,index3) in list.attribute_list"
                      :key="index3"
                      :value="listchild">
                    </el-option>
                  </el-select>
                </p>
              </div>
            </div>

            <!--计算属性-->
            <div class="attributebox" v-if="typeof itme2.productAttribute === 'object' && itme2.select==='active'">
              <div>
                <p :key="list.attribute_id"
                   :class="indexone==0?'one':''"
                   v-if="list.in_formula===1"
                   v-for="(list,indexone) in itme2.productAttribute">
                  {{list.product_attribute_name_title}}:
                  <el-input v-if="!list.attribute_list"
                            v-model="list.product_attribute_name"
                            @blur="onattributeSizerange(itme2.Identification,list.attribute_id,list.restriction_min,list.restriction_max)"
                            @input="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                            type="number"
                            size="mini"></el-input>
                  <!--<select @change="onAccessoriesinput2(itme2.product_id)" v-if="list.attribute_list" v-model="list.product_attribute_name">-->
                  <!--<option :key="index3" v-for="(listchild,index3) in list.attribute_list">{{listchild}}</option>-->
                  <!--</select>-->
                  <el-select  @change="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                              v-model="list.product_attribute_name"
                              v-if="list.attribute_list && list.product_attribute_name_title!=='顏色'">
                    <el-option
                      v-for="(listchild) in list.attribute_list"
                      :key="listchild"
                      :label="listchild"
                      :value="listchild">
                    </el-option>
                  </el-select>
                </p>
                <p v-if="typeof itme2.productAttribute === 'object'">
                  <!--<span class="formula">公式：</span>-->
                  <span v-html="itme2.productCalculationFormula"></span>
                </p>
                <p v-if="typeof itme2.multiplesAttribute === 'object'">
                  <span class="formula">倍数公式：</span>
                  <span v-html="itme2.multiplesFormula"></span>
                </p>
                <p class="towbottom" v-if="typeof itme2.productAttribute === 'object'"><span>结果：{{itme2.result}}</span></p>
              </div>
            </div>

            <p v-if="itme2.select==='active'" class="sunbox">
              <span @click="onreduce(itme2.Identification)" class="reduce">-</span>
              <span class="num">{{itme2.sun}}</span>
              <span @click="onadd(itme2.Identification)" class="add">+</span>
            </p>

          </li>
        </ul>

        <!--三级配件-->
        <h1 v-if="showsparts3.length">{{showspartsname3}}</h1>
        <ul v-if="showsparts3.length" class="clearfloat childPartsData">
          <li :class="itme2.select" :key="childindex" v-for="(itme2,childindex) in showsparts3">
            <img @click.capture="onselect(itme2.Identification)"
                 onerror="onerror=null;src='./static/img/buf.e019189.png'"
                 :src="itme2.bigImageUrl?itme2.bigImageUrl:buf"/>
            <div class="titlebox">
              <p class="tltle">{{itme2.name}}</p>
              <p v-if="itme2.second_price>0" class="productAccessoriesPrice">{{itme2.currency_symbol}} {{itme2.second_price}}</p>
              <p class="selectedquantity">
                安裝費用：{{itme2.installation_charge_currency_symbol}} {{itme2.installation_charge}}
                <span v-if="itme2.select!=='active' && itme2.sun>0">x {{itme2.sun}}</span>
              </p>
            </div>
            <!--属性组合-->
            <div class="attributebox give" v-if="itme2.AttributeGroup && itme2.select==='active'">
              组合属性：
              <el-select @change="onAccessoriesinput(itme2.Identification)"
                         v-model="itme2.composite_attribute_value">
                <el-option
                  v-for="(list,index) in itme2.AttributeGroup"
                  :key="index"
                  :label="list.attribute_value_group"
                  :value="list.id">
                </el-option>
              </el-select>
            </div>
            <!--属性-->
            <div class="attributebox"
                 v-if="typeof itme2.attribute_data === 'object' && itme2.select==='active'">
              <div>
                <p :key="list.product_attribute_id"
                   v-for="(list) in itme2.attribute_data">
                  <!--{{list.product_attribute_name_title}}：{{list.product_attribute_name}}-->
                  {{list.product_attribute_name_title}}:
                  <el-input v-if="!list.attribute_list"
                            v-model="list.product_attribute_name"
                            @blur="onattributeSizerange(itme2.Identification,list.attribute_id,list.restriction_min,list.restriction_max)"
                            @input="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                            size="mini"></el-input>
                  <el-select  @change="list.select_type!=='2' && onAccessoriesinput(itme2.Identification)"
                              :multiple="list.select_type==='2'"
                              :disabled="list.disabled"
                              v-model="list.product_attribute_name"
                              v-if="list.attribute_list && list.product_attribute_name_title!=='顏色'">
                    <el-option
                      v-for="(listchild) in list.attribute_list"
                      :key="listchild"
                      :label="listchild"
                      :value="listchild">
                    </el-option>
                  </el-select>
                  <!--颜色-->
                  <el-select
                    v-if="list.attribute_list && list.product_attribute_name_title=='顏色'"
                    :style="{'background': list.product_attribute_name}"
                    class="popper-class"
                    size="mini"
                    v-model="list.product_attribute_name" placeholder="请选择">
                    <el-option
                      class="selectitme"
                      :style="{'background-color': listchild}"
                      v-for="(listchild,index3) in list.attribute_list"
                      :key="index3"
                      :value="listchild">
                    </el-option>
                  </el-select>
                </p>
              </div>
            </div>

            <!--计算属性-->
            <div class="attributebox" v-if="typeof itme2.attribute_data === 'object' && itme2.select==='active'">
              <div>
                <p :key="list.attribute_id"
                   :class="indexone==0?'one':''"
                   v-if="list.in_formula===1"
                   v-for="(list,indexone) in itme2.attribute_data">
                  {{list.product_attribute_name_title}}:
                  <el-input v-if="!list.attribute_list"
                            v-model="list.product_attribute_name"
                            @blur="onattributeSizerange(itme2.Identification,list.attribute_id,list.restriction_min,list.restriction_max)"
                            @input="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                            type="number"
                            size="mini"></el-input>
                  <el-select  @change="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                              v-model="list.product_attribute_name"
                              v-if="list.attribute_list && list.product_attribute_name_title!=='顏色'">
                    <el-option
                      v-for="(listchild) in list.attribute_list"
                      :key="listchild"
                      :label="listchild"
                      :value="listchild">
                    </el-option>
                  </el-select>
                </p>
                <p v-if="typeof itme2.calculation_attribute === 'object'">
                  <!--<span class="formula">公式：</span>-->
                  <span v-html="itme2.calculation_formula"></span>
                </p>
                <p v-if="typeof itme2.multiplesAttribute === 'object'">
                  <span class="formula">倍数公式：</span>
                  <span v-html="itme2.multiplesFormula"></span>
                </p>
                <p class="towbottom" v-if="typeof itme2.calculation_attribute === 'object'"><span>结果：{{itme2.result}}</span></p>
              </div>
            </div>

            <p v-if="itme2.select==='active'" class="sunbox">
              <span @click="onreduce(itme2.Identification)" class="reduce">-</span>
              <span class="num">{{itme2.sun}}</span>
              <span @click="onadd(itme2.Identification)" class="add">+</span>
            </p>

          </li>
        </ul>

        <!--四级配件-->
        <h1 v-if="showsparts4.length">{{showspartsname4}}</h1>
        <ul v-if="showsparts4.length" class="clearfloat childPartsData">
          <li :class="itme2.select" :key="childindex" v-for="(itme2,childindex) in showsparts4">
            <img @click.capture="onselect(itme2.Identification)"
                 onerror="onerror=null;src='./static/img/buf.e019189.png'"
                 :src="itme2.bigImageUrl?itme2.bigImageUrl:buf"/>
            <div class="titlebox">
              <p class="tltle">{{itme2.name}}</p>
              <p v-if="itme2.second_price>0" class="productAccessoriesPrice">{{itme2.currency_symbol}} {{itme2.second_price}}</p>
              <p class="selectedquantity">
                安裝費用：{{itme2.installation_charge_currency_symbol}} {{itme2.installation_charge}}
                <span v-if="itme2.select!=='active' && itme2.sun>0">x {{itme2.sun}}</span>
              </p>
            </div>
            <!--属性组合-->
            <div class="attributebox give" v-if="itme2.AttributeGroup && itme2.select==='active'">
              组合属性：
              <el-select @change="onAccessoriesinput(itme2.Identification)"
                         v-model="itme2.composite_attribute_value">
                <el-option
                  v-for="(list,index) in itme2.AttributeGroup"
                  :key="index"
                  :label="list.attribute_value_group"
                  :value="list.id">
                </el-option>
              </el-select>
            </div>
            <!--属性-->
            <div class="attributebox"
                 v-if="typeof itme2.attribute_data === 'object' && itme2.select==='active'">
              <div>
                <p :key="list.product_attribute_id"
                   v-for="(list) in itme2.attribute_data">
                  <!--{{list.product_attribute_name_title}}：{{list.product_attribute_name}}-->
                  {{list.product_attribute_name_title}}:
                  <el-input v-if="!list.attribute_list"
                            v-model="list.product_attribute_name"
                            @blur="onattributeSizerange(itme2.Identification,list.attribute_id,list.restriction_min,list.restriction_max)"
                            @input="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                            size="mini"></el-input>
                  <el-select  @change="list.select_type!=='2' && onAccessoriesinput(itme2.Identification)"
                              :multiple="list.select_type==='2'"
                              :disabled="list.disabled"
                              v-model="list.product_attribute_name"
                              v-if="list.attribute_list && list.product_attribute_name_title!=='顏色'">
                    <el-option
                      v-for="(listchild) in list.attribute_list"
                      :key="listchild"
                      :label="listchild"
                      :value="listchild">
                    </el-option>
                  </el-select>
                  <!--颜色-->
                  <el-select
                    v-if="list.attribute_list && list.product_attribute_name_title=='顏色'"
                    :style="{'background': list.product_attribute_name}"
                    class="popper-class"
                    size="mini"
                    v-model="list.product_attribute_name" placeholder="请选择">
                    <el-option
                      class="selectitme"
                      :style="{'background-color': listchild}"
                      v-for="(listchild,index3) in list.attribute_list"
                      :key="index3"
                      :value="listchild">
                    </el-option>
                  </el-select>
                </p>
              </div>
            </div>

            <!--计算属性-->
            <div class="attributebox" v-if="typeof itme2.attribute_data === 'object' && itme2.select==='active'">
              <div>
                <p :key="list.attribute_id"
                   :class="indexone==0?'one':''"
                   v-if="list.in_formula===1"
                   v-for="(list,indexone) in itme2.attribute_data">
                  {{list.product_attribute_name_title}}:
                  <el-input v-if="!list.attribute_list"
                            v-model="list.product_attribute_name"
                            @blur="onattributeSizerange(itme2.Identification,list.attribute_id,list.restriction_min,list.restriction_max)"
                            @input="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                            type="number"
                            size="mini"></el-input>
                  <el-select  @change="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                              v-model="list.product_attribute_name"
                              v-if="list.attribute_list && list.product_attribute_name_title!=='顏色'">
                    <el-option
                      v-for="(listchild) in list.attribute_list"
                      :key="listchild"
                      :label="listchild"
                      :value="listchild">
                    </el-option>
                  </el-select>
                </p>
                <p v-if="typeof itme2.calculation_attribute === 'object'">
                  <!--<span class="formula">公式：</span>-->
                  <span v-html="itme2.calculation_formula"></span>
                </p>
                <p v-if="typeof itme2.multiplesAttribute === 'object'">
                  <span class="formula">倍数公式：</span>
                  <span v-html="itme2.multiplesFormula"></span>
                </p>
                <p class="towbottom" v-if="typeof itme2.calculation_attribute === 'object'"><span>结果：{{itme2.result}}</span></p>
              </div>
            </div>

            <p v-if="itme2.select==='active'" class="sunbox">
              <span @click="onreduce(itme2.Identification)" class="reduce">-</span>
              <span class="num">{{itme2.sun}}</span>
              <span @click="onadd(itme2.Identification)" class="add">+</span>
            </p>

          </li>
        </ul>

        <!--五级配件-->
        <h1 v-if="showsparts5.length">{{showspartsname5}}</h1>
        <ul v-if="showsparts5.length" class="clearfloat childPartsData">
          <li :class="itme2.select" :key="childindex" v-for="(itme2,childindex) in showsparts5">
            <img @click.capture="onselect(itme2.Identification)"
                 onerror="onerror=null;src='./static/img/buf.e019189.png'"
                 :src="itme2.bigImageUrl?itme2.bigImageUrl:buf"/>
            <div class="titlebox">
              <p class="tltle">{{itme2.name}}</p>
              <p v-if="itme2.second_price>0" class="productAccessoriesPrice">{{itme2.currency_symbol}} {{itme2.second_price}}</p>
              <p class="selectedquantity">
                安裝費用：{{itme2.installation_charge_currency_symbol}} {{itme2.installation_charge}}
                <span v-if="itme2.select!=='active' && itme2.sun>0">x {{itme2.sun}}</span>
              </p>
            </div>
            <!--属性组合-->
            <div class="attributebox give" v-if="itme2.AttributeGroup && itme2.select==='active'">
              组合属性：
              <el-select @change="onAccessoriesinput(itme2.Identification)"
                         v-model="itme2.composite_attribute_value">
                <el-option
                  v-for="(list,index) in itme2.AttributeGroup"
                  :key="index"
                  :label="list.attribute_value_group"
                  :value="list.id">
                </el-option>
              </el-select>
            </div>
            <!--属性-->
            <div class="attributebox"
                 v-if="typeof itme2.attribute_data === 'object' && itme2.select==='active'">
              <div>
                <p :key="list.product_attribute_id"
                   v-for="(list) in itme2.attribute_data">
                  <!--{{list.product_attribute_name_title}}：{{list.product_attribute_name}}-->
                  {{list.product_attribute_name_title}}:
                  <el-input v-if="!list.attribute_list"
                            v-model="list.product_attribute_name"
                            @blur="onattributeSizerange(itme2.Identification,list.attribute_id,list.restriction_min,list.restriction_max)"
                            @input="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                            size="mini"></el-input>
                  <el-select  @change="list.select_type!=='2' && onAccessoriesinput(itme2.Identification)"
                              :multiple="list.select_type==='2'"
                              :disabled="list.disabled"
                              v-model="list.product_attribute_name"
                              v-if="list.attribute_list && list.product_attribute_name_title!=='顏色'">
                    <el-option
                      v-for="(listchild) in list.attribute_list"
                      :key="listchild"
                      :label="listchild"
                      :value="listchild">
                    </el-option>
                  </el-select>
                  <!--颜色-->
                  <el-select
                    v-if="list.attribute_list && list.product_attribute_name_title=='顏色'"
                    :style="{'background': list.product_attribute_name}"
                    class="popper-class"
                    size="mini"
                    v-model="list.product_attribute_name" placeholder="请选择">
                    <el-option
                      class="selectitme"
                      :style="{'background-color': listchild}"
                      v-for="(listchild,index3) in list.attribute_list"
                      :key="index3"
                      :value="listchild">
                    </el-option>
                  </el-select>
                </p>
              </div>
            </div>

            <!--计算属性-->
            <div class="attributebox" v-if="typeof itme2.attribute_data === 'object' && itme2.select==='active'">
              <div>
                <p :key="list.attribute_id"
                   :class="indexone==0?'one':''"
                   v-if="list.in_formula===1"
                   v-for="(list,indexone) in itme2.attribute_data">
                  {{list.product_attribute_name_title}}:
                  <el-input v-if="!list.attribute_list"
                            v-model="list.product_attribute_name"
                            @blur="onattributeSizerange(itme2.Identification,list.attribute_id,list.restriction_min,list.restriction_max)"
                            @input="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                            type="number"
                            size="mini"></el-input>
                  <el-select  @change="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                              v-model="list.product_attribute_name"
                              v-if="list.attribute_list && list.product_attribute_name_title!=='顏色'">
                    <el-option
                      v-for="(listchild) in list.attribute_list"
                      :key="listchild"
                      :label="listchild"
                      :value="listchild">
                    </el-option>
                  </el-select>
                </p>
                <p v-if="typeof itme2.calculation_attribute === 'object'">
                  <!--<span class="formula">公式：</span>-->
                  <span v-html="itme2.calculation_formula"></span>
                </p>
                <p v-if="typeof itme2.multiplesAttribute === 'object'">
                  <span class="formula">倍数公式：</span>
                  <span v-html="itme2.multiplesFormula"></span>
                </p>
                <p class="towbottom" v-if="typeof itme2.calculation_attribute === 'object'"><span>结果：{{itme2.result}}</span></p>
              </div>
            </div>

            <p v-if="itme2.select==='active'" class="sunbox">
              <span @click="onreduce(itme2.Identification)" class="reduce">-</span>
              <span class="num">{{itme2.sun}}</span>
              <span @click="onadd(itme2.Identification)" class="add">+</span>
            </p>

          </li>
        </ul>

        <!--六级配件-->
        <h1 v-if="showsparts6.length">{{showspartsname6}}</h1>
        <ul v-if="showsparts6.length" class="clearfloat childPartsData">
          <li :class="itme2.select" :key="childindex" v-for="(itme2,childindex) in showsparts6">
            <img @click.capture="onselect(itme2.Identification)"
                 onerror="onerror=null;src='./static/img/buf.e019189.png'"
                 :src="itme2.bigImageUrl?itme2.bigImageUrl:buf"/>
            <div class="titlebox">
              <p class="tltle">{{itme2.name}}</p>
              <p v-if="itme2.second_price>0" class="productAccessoriesPrice">{{itme2.currency_symbol}} {{itme2.second_price}}</p>
              <p class="selectedquantity">
                安裝費用：{{itme2.installation_charge_currency_symbol}} {{itme2.installation_charge}}
                <span v-if="itme2.select!=='active' && itme2.sun>0">x {{itme2.sun}}</span>
              </p>
            </div>
            <!--属性组合-->
            <div class="attributebox give" v-if="itme2.AttributeGroup && itme2.select==='active'">
              组合属性：
              <el-select @change="onAccessoriesinput(itme2.Identification)"
                         v-model="itme2.composite_attribute_value">
                <el-option
                  v-for="(list,index) in itme2.AttributeGroup"
                  :key="index"
                  :label="list.attribute_value_group"
                  :value="list.id">
                </el-option>
              </el-select>
            </div>
            <!--属性-->
            <div class="attributebox"
                 v-if="typeof itme2.attribute_data === 'object' && itme2.select==='active'">
              <div>
                <p :key="list.product_attribute_id"
                   v-for="(list) in itme2.attribute_data">
                  <!--{{list.product_attribute_name_title}}：{{list.product_attribute_name}}-->
                  {{list.product_attribute_name_title}}:
                  <el-input v-if="!list.attribute_list"
                            v-model="list.product_attribute_name"
                            @blur="onattributeSizerange(itme2.Identification,list.attribute_id,list.restriction_min,list.restriction_max)"
                            @input="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                            size="mini"></el-input>
                  <el-select  @change="list.select_type!=='2' && onAccessoriesinput(itme2.Identification)"
                              :multiple="list.select_type==='2'"
                              :disabled="list.disabled"
                              v-model="list.product_attribute_name"
                              v-if="list.attribute_list && list.product_attribute_name_title!=='顏色'">
                    <el-option
                      v-for="(listchild) in list.attribute_list"
                      :key="listchild"
                      :label="listchild"
                      :value="listchild">
                    </el-option>
                  </el-select>
                  <!--颜色-->
                  <el-select
                    v-if="list.attribute_list && list.product_attribute_name_title=='顏色'"
                    :style="{'background': list.product_attribute_name}"
                    class="popper-class"
                    size="mini"
                    v-model="list.product_attribute_name" placeholder="请选择">
                    <el-option
                      class="selectitme"
                      :style="{'background-color': listchild}"
                      v-for="(listchild,index3) in list.attribute_list"
                      :key="index3"
                      :value="listchild">
                    </el-option>
                  </el-select>
                </p>
              </div>
            </div>

            <!--计算属性-->
            <div class="attributebox" v-if="typeof itme2.attribute_data === 'object' && itme2.select==='active'">
              <div>
                <p :key="list.attribute_id"
                   :class="indexone==0?'one':''"
                   v-if="list.in_formula===1"
                   v-for="(list,indexone) in itme2.attribute_data">
                  {{list.product_attribute_name_title}}:
                  <el-input v-if="!list.attribute_list"
                            v-model="list.product_attribute_name"
                            @blur="onattributeSizerange(itme2.Identification,list.attribute_id,list.restriction_min,list.restriction_max)"
                            @input="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                            type="number"
                            size="mini"></el-input>
                  <el-select  @change="onAccessoriesinput(itme2.Identification,list.attribute_id)"
                              v-model="list.product_attribute_name"
                              v-if="list.attribute_list && list.product_attribute_name_title!=='顏色'">
                    <el-option
                      v-for="(listchild) in list.attribute_list"
                      :key="listchild"
                      :label="listchild"
                      :value="listchild">
                    </el-option>
                  </el-select>
                </p>
                <p v-if="typeof itme2.calculation_attribute === 'object'">
                  <!--<span class="formula">公式：</span>-->
                  <span v-html="itme2.calculation_formula"></span>
                </p>
                <p v-if="typeof itme2.multiplesAttribute === 'object'">
                  <span class="formula">倍数公式：</span>
                  <span v-html="itme2.multiplesFormula"></span>
                </p>
                <p class="towbottom" v-if="typeof itme2.calculation_attribute === 'object'"><span>结果：{{itme2.result}}</span></p>
              </div>
            </div>

            <p v-if="itme2.select==='active'" class="sunbox">
              <span @click="onreduce(itme2.Identification)" class="reduce">-</span>
              <span class="num">{{itme2.sun}}</span>
              <span @click="onadd(itme2.Identification)" class="add">+</span>
            </p>

          </li>
        </ul>

        <div class="onproductAccessories" v-if="typeof productAccessories !== 'object'">{{productAccessories}}</div>
      </div>
      <div class="pcbox2">
        <div class="l">
          <div class="totalbox">
            <span>總價</span>
            <span>HKD {{total}}</span>
          </div>
          <div class="remarks">
            <textarea v-model="detail.goods_remark" placeholder="備註："></textarea>
          </div>
        </div>
        <div class="r">
          <div class="usermeassagebox">

            <ul>
              <li>
                A：<input v-model="remarks[0]"/>
              </li>
              <li>
                B：<input v-model="remarks[1]"/>
              </li>
              <li>
                C：<input v-model="remarks[2]"/>
              </li>
              <li>
                D：<input v-model="remarks[3]"/>
              </li>
              <li>
                E：<input v-model="remarks[4]"/>
              </li>
            </ul>
            <div>
              <img v-if="detail.product_quotation_style_type == 1 || detail.product_quotation_style_type == 0" src="../assets/images/03.png" alt="">
              <img v-if="detail.product_quotation_style_type == 2" src="../assets/images/01.jpg" alt="">
            </div>
          </div>
          <div @click="onmessagebox" class="butbox">現在訂購</div>
        </div>
      </div>
    </div>
</template>

<script>
  import { MessageBox,Popup  } from 'mint-ui';
  import Dot from '../assembly/Dot/Dot';
  import buf from '../assets/images/buf.png'
  import ScrollPosition from '../assets/js/scroll-position'
  import {
    getProDetail,
    LocalShoppingCart,
    curtainlogout,
    productFormula,
    getProActionPrice,
    getProductAttributeGroupPrice,
    productInstallationSite
  } from '../assets/js/api'
    export default {
        name: "shop",
        data(){
          return{
            buf,
            popupVisible:false,
            detail:{},
            productAccessories:{},
            productAttribute:[],
            productCalculationFormula:'',
            multiplesFormula:'',
            num:1,
            userinfo:[],
            remarks:[],
            showsparts2:[],
            showspartsname2:'',

            showsparts3:[],
            showspartsname3:'',

            showsparts4:[],
            showspartsname4:'',

            showsparts5:[],
            showspartsname5:'',

            showsparts6:[],
            showspartsname6:'',
            minAccessories:'none',
            mixAccessories:0,
            combinationattributes:[],
            attribute_group_value:'',

            prodetail:[]
          }
        },
        components:{
          MessageBox,
          Popup,
          Dot,
        },
        mounted(){

          productInstallationSite(localStorage.getItem('installation')).then((data)=>{
            this.prodetail = data.info.all[0].prodetail
            console.log(this.prodetail)
          })
          this.getProDetail(138170)
          ScrollPosition.goTop.call(this);

        },
        methods:{
          // 获取产品数据
          getProDetail(id){
            getProDetail(id).then((data)=>{
              this.detail = data.detail
              this.productCalculationFormula = data.productCalculationFormula //计算公式
              this.multiplesFormula = data.multiplesFormula //倍数公式
              let html1 = document.createElement('p')
              html1.innerHTML = this.detail.product_description
              this.detail.product_description = html1.innerText

              console.log(data)


              //处理产品属性
              if (typeof data.productAttribute === 'object') {
                data.productAttribute.map(itme=>{
                  // 回写上次输入的属性值
                  itme.disabled = false //组合属性有的属性在属性列表禁止选择
                  this.$store.state.defaultAttributeValue.map(defaults=>{
                    if (itme.attribute_id === defaults.attribute_id && defaults.product_attribute_name !=='') {
                      itme.product_attribute_name = defaults.product_attribute_name
                    }
                  })
                  if (itme.select_type==='2' && typeof itme.product_attribute_name !== 'object'){
                    itme.product_attribute_name = [itme.product_attribute_name]
                  }
                })
                this.productAttribute = data.productAttribute
              }

              // 请求产品组合属性
              this.getGroupAttribute()

              if(typeof this.productAccessories === 'object'){
                this.productAccessories = data.productAccessories // 产品配件含子配件
              }
              else {
                this.productAccessories = [] // 产品配件含子配件
              }


              if (typeof this.productAccessories === 'object'){
                //初始化配件
                this.productAccessories.map((itme)=>{
                  itme.sun = 0    //数量
                  itme.result = 0 //计算价格
                  itme.Identification = this.guid() //配件的唯一标识时间戳加随机数
                  // itme.result = 0 //是否显示公式
                  if (!itme.productAccessoriesPrice) {
                    itme.productAccessoriesPrice = 0
                  }
                  //是否使用百分比计算配件价格
                  if (itme.productAccessoriesPointType === '1'){
                    itme.productAccessoriesPrice = Number.parseFloat((this.detail.expend_price*this.num)*(itme.productAccessoriesPoint/100))
                  }
                  // 计算配件最低价格和最高价格
                  if (this.minAccessories === 'none'){
                    this.minAccessories = Number.parseFloat(itme.productAccessoriesPrice)
                  }
                  if (Number.parseFloat(itme.productAccessoriesPrice) > this.mixAccessories){
                    this.mixAccessories = Number.parseFloat(itme.productAccessoriesPrice)
                  }
                  if (this.minAccessories > Number.parseFloat(itme.productAccessoriesPrice)){
                    this.minAccessories = Number.parseFloat(itme.productAccessoriesPrice)
                  }

                  // 初始化配件属性
                  if (typeof itme.productAttribute === 'object') {
                    itme.productAttribute.map(selects=>{
                      if (selects.select_type==='2'){
                        selects.product_attribute_name = [selects.product_attribute_name]
                      }
                    })
                  }
                  //初始化子配件
                  if (typeof itme.partsInPartsData === 'object') {
                    itme.partsInPartsData.map((itme2)=>{
                      itme2.sun = 0
                      itme2.result = 0
                      itme2.Identification = this.guid() //配件的唯一标识时间戳加随机数
                      if (!itme2.productAccessoriesPrice) {
                        itme2.productAccessoriesPrice = 0
                      }
                      // 初始化子配件属性
                      if (typeof itme2.productAttribute === 'object') {
                        itme2.productAttribute.map(selects=>{
                          if (selects.select_type==='2'){
                            selects.product_attribute_name = [selects.product_attribute_name]
                          }
                        })
                      }
                      //初始化第三级配件
                      if (typeof itme2.sub_level_data === 'object') {
                        itme2.sub_level_data.map((itme3)=>{
                          itme3.sun = 0
                          itme3.result = 0
                          itme3.Identification = this.guid() //配件的唯一标识时间戳加随机数
                          if (!itme3.second_price) {
                            itme3.second_price = 0
                          }
                          // 初始化第三配件属性
                          if (typeof itme3.attribute_data === 'object') {
                            itme3.attribute_data.map(selects=>{
                              if (selects.select_type==='2'){
                                selects.product_attribute_name = [selects.product_attribute_name]
                              }
                            })
                          }
                          //初始化第四级配件
                          if (typeof itme3.sub_level_data === 'object') {
                            itme3.sub_level_data.map((itme4)=>{
                              itme4.sun = 0
                              itme4.result = 0
                              itme4.Identification = this.guid() //配件的唯一标识时间戳加随机数
                              if (!itme4.second_price) {
                                itme4.second_price = 0
                              }
                              // 初始化第四配件属性
                              if (typeof itme4.attribute_data === 'object') {
                                itme4.attribute_data.map(selects=>{
                                  if (selects.select_type==='2'){
                                    selects.product_attribute_name = [selects.product_attribute_name]
                                  }
                                })
                              }
                              //初始化第五级配件
                              if (typeof itme4.sub_level_data === 'object') {
                                itme4.sub_level_data.map((itme5)=>{
                                  itme5.sun = 0
                                  itme5.result = 0
                                  itme5.Identification = this.guid() //配件的唯一标识时间戳加随机数
                                  if (!itme5.second_price) {
                                    itme5.second_price = 0
                                  }
                                  // 初始化第五配件属性
                                  if (typeof itme5.attribute_data === 'object') {
                                    itme5.attribute_data.map(selects=>{
                                      if (selects.select_type==='2'){
                                        selects.product_attribute_name = [selects.product_attribute_name]
                                      }
                                    })
                                  }
                                  //初始化第六级配件
                                  if (typeof itme5.sub_level_data === 'object') {
                                    itme5.sub_level_data.map((itme6)=>{
                                      itme6.sun = 0
                                      itme6.result = 0
                                      itme6.Identification = this.guid() //配件的唯一标识时间戳加随机数
                                      if (!itme6.second_price) {
                                        itme6.second_price = 0
                                      }
                                      // 初始化第六配件属性
                                      if (typeof itme6.attribute_data === 'object') {
                                        itme6.attribute_data.map(selects=>{
                                          if (selects.select_type==='2'){
                                            selects.product_attribute_name = [selects.product_attribute_name]
                                          }
                                        })
                                      }
                                    })
                                  }
                                })
                              }
                            })
                          }
                        })
                      }
                    })
                  }
                })
              }
              //循环配件 同步配件和产品的属性
              for (let i=0;i<this.productAttribute.length;i++){
                if (typeof this.productAccessories === 'object') {
                  this.productAccessories.map((itmes)=>{
                    if (typeof itmes.productAttribute === 'object') {
                      itmes.productAttribute.map(lsit=>{
                        if (lsit.attribute_id === this.productAttribute[i].attribute_id) {
                          lsit.product_attribute_name = this.productAttribute[i].product_attribute_name
                        }
                      })
                    }
                    if (typeof itmes.partsInPartsData === 'object') {
                      //循环子配件
                      itmes.partsInPartsData.map((itme2)=>{
                        if (typeof itme2.productAttribute === 'object') {
                          itme2.productAttribute.map(lsit=>{
                            if (lsit.attribute_id === this.productAttribute[i].attribute_id) {
                              lsit.product_attribute_name = this.productAttribute[i].product_attribute_name
                            }
                          })
                        }
                        if (typeof itme2.sub_level_data === 'object') {
                          // 循环第三级配件
                          itme2.sub_level_data.map(itme3=>{
                            if (typeof itme3.attribute_data === 'object' && itme3.attribute_data !== null) {
                              itme3.attribute_data.map(lsit=>{
                                if (lsit.attribute_id === this.productAttribute[i].attribute_id) {
                                  lsit.product_attribute_name = this.productAttribute[i].product_attribute_name
                                }
                              })
                            }
                            if (typeof itme3.sub_level_data === 'object') {
                              // 循环第四级配件
                              itme3.sub_level_data.map(itme4=>{
                                if (typeof itme4.attribute_data === 'object' && itme4.attribute_data !== null) {
                                  itme4.attribute_data.map(lsit=>{
                                    if (lsit.attribute_id === this.productAttribute[i].attribute_id) {
                                      lsit.product_attribute_name = this.productAttribute[i].product_attribute_name
                                    }
                                  })
                                }
                                if (typeof itme4.sub_level_data === 'object') {
                                  // 循环第五级配件
                                  itme4.sub_level_data.map(itme5=>{
                                    if (typeof itme5.attribute_data === 'object' && itme5.attribute_data !== null) {
                                      itme5.attribute_data.map(lsit=>{
                                        if (lsit.attribute_id === this.productAttribute[i].attribute_id) {
                                          lsit.product_attribute_name = this.productAttribute[i].product_attribute_name
                                        }
                                      })
                                    }
                                    if (typeof itme5.sub_level_data === 'object') {
                                      // 循环第六级配件
                                      itme5.sub_level_data.map(itme6=>{
                                        if (typeof itme6.attribute_data === 'object' && itme6.attribute_data !== null) {
                                          itme6.attribute_data.map(lsit=>{
                                            if (lsit.attribute_id === this.productAttribute[i].attribute_id) {
                                              lsit.product_attribute_name = this.productAttribute[i].product_attribute_name
                                            }
                                          })
                                        }
                                      })
                                    }
                                  })
                                }
                              })
                            }
                          })
                        }
                      })
                    }
                  })
                }

              }
              //按产品数量和价格初始化配件价格
              this.product_reduce_add()

              this.oninput()
              // this.onAccessoriesinput()
              // this.onAccessoriesinput2()
              // this.onAccessoriesinput3()
            })
          },
          //请求组合属性方法
          getGroupAttribute(){
            getProductAttributeGroupPrice(this.$route.query.product_id).then(data=>{
              if (data.status && data.data!==null) {
                this.combinationattributes = data.data
                let attribute_id_group = []
                this.combinationattributes.map(itme=>{
                  let a = itme.attribute_id_group.split(',')
                  attribute_id_group = attribute_id_group.concat(a)
                })
                attribute_id_group = Array.from(new Set(attribute_id_group))
                attribute_id_group.map(itme=>{
                  this.productAttribute.map(list=>{
                    if (itme === list.attribute_id) {
                      list.disabled = true
                    }
                  })
                })
              }
            })
          },
          // 选择产品组合属性
          selectattributes(){
            let itme = this.combinationattributes[this.attribute_group_value]
            this.detail.attribute_group_id = itme.id //产品组合属性id
            this.detail.expend_price = itme.attribute_group_price
            itme.attribute_id_group.split(',').map((asttr,index)=>{
              this.productAttribute.map(prooattr=>{
                if (asttr === prooattr.attribute_id) {
                  prooattr.product_attribute_name = itme.attribute_value_group.split('×')[index]
                }
              })
            })
            this.oninput()
          },
          S4() {
            return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
          },
          guid() {
            return (this.S4()+this.S4());
          },
          inorderlist(){
            this.$store.commit('set_inorderilstroutername','shop?id='+this.$route.query.id+'&product_id='+this.$route.query.product_id)
            this.$router.push({ path: '/orderlist'});
          },
          reopenNewOrder(){
            if (this.$store.state.client){
              MessageBox({
                title: '提示',
                message: '您确定重开新单吗？',
                showCancelButton: true,
                confirmButtonText:"确定",
                cancelButtonText:"取消"
              }).then((confirm)=>{
                if (confirm === 'confirm'){
                  sessionStorage.removeItem('LocalShoppingCart');
                  sessionStorage.removeItem('order_id');
                  sessionStorage.removeItem('quotation_code');
                  this.$store.commit('res_state')
                  this.$router.push({ path: '/index'});
                }
              });
            }
            else {
              this.$confirm('您确定重开新单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                distinguishCancelAndClose: true,
                type: 'warning'
              }).then(() => {
                sessionStorage.removeItem('LocalShoppingCart');
                sessionStorage.removeItem('order_id');
                sessionStorage.removeItem('quotation_code');
                this.$store.commit('res_state')
                this.$router.push({ path: '/index'});
              }).catch((c) => {});
            }
          },
          showPersonalCenter(){
            this.popupVisible ? this.popupVisible = false : this.popupVisible = true
          },
          curtainlogout(){
            curtainlogout().then(data=>{
              sessionStorage.removeItem('LocalShoppingCart');
              sessionStorage.removeItem('order_id');
              localStorage.removeItem('logindata');
              localStorage.removeItem('userdata');
              this.$store.commit('res_state')
              this.$router.push({ path: '/'});
            })
          },
          //减少主产品数量
          productreduce(){
            this.num>1?this.num-=1:'';
            //数量变化请求接口，判断是否改变产品单价，如果是，调用计算公式
            getProActionPrice(this.detail.product_id,this.num).then(data=>{
              if (this.detail.expend_price !== data.price) {
                this.detail.expend_price = data.price
                this.oninput()
              }
              else {
                this.product_reduce_add()
              }
            })
          },
          //增加主产品数量
          productadd(){
            this.num+=1;
            //数量变化请求接口，判断是否改变产品单价，如果是，调用计算公式
            getProActionPrice(this.detail.product_id,this.num).then(data=>{
              if (this.detail.expend_price !== data.price) {
                this.detail.expend_price = data.price
                this.oninput()
              }
              else {
                this.product_reduce_add()
              }
            })
          },
          //匹配产品的数值范围
          onSizerange(e){
            let attribute_id = e.target.getAttribute('data-attribute_id')
            let min = Number.parseFloat(e.target.getAttribute('data-min'))
            let max =Number.parseFloat(e.target.getAttribute('data-max'))
            this.productAttribute.map((itme)=>{
              if (itme.attribute_id === attribute_id) {
                if(min && itme.product_attribute_name < min){
                  itme.product_attribute_name = min
                  //变为指定的范围值时调用公式计算重新计算
                  this.oninput()
                }
                else if (max && itme.product_attribute_name > max) {
                  itme.product_attribute_name = max
                  //变为指定的范围值时调用公式计算重新计算
                  this.oninput()
                }
              }
            })
          },
          //产品的计算公式调用
          oninput(){
            let obj={
              formula_id:this.detail.product_formula_id,
              product_id:this.detail.product_id,
              attr_id:this.detail.product_attribute_ids
            }
            if (typeof this.productAttribute !== 'object') {
              this.$set(this.detail,'result',this.detail.expend_price)
              return
            }
            for (let i=0;i<this.productAttribute.length;i++){
              //下拉框的选项为'() 或 （）'时变为输入框
              if (this.productAttribute[i].product_attribute_name === '（）' || this.productAttribute[i].product_attribute_name === '()'){
                this.productAttribute[i].product_attribute_name = ''
                delete this.productAttribute[i].attribute_list
              }

              if (this.productAttribute[i].product_attribute_name === '') {
                obj['formula_'+this.productAttribute[i].attribute_id] = 0
              }
              else if (this.productAttribute[i].in_formula===1) {
                obj['formula_'+this.productAttribute[i].attribute_id] = this.productAttribute[i].product_attribute_name
              }
            }
            productFormula(obj).then((data)=>{
              if (data.status){
                this.$set(this.detail,'result',data.info.result*this.detail.expend_price)
              }
              else {
                this.$set(this.detail,'result',1*this.detail.expend_price)
              }
              this.product_reduce_add()
            })
            //循环配件 同步配件和产品的属性
            for (let i=0;i<this.productAttribute.length;i++){
              if (typeof this.productAccessories === 'object') {
                this.productAccessories.map((itmes)=>{
                  if (typeof itmes.productAttribute === 'object' && itmes.sun === 0) {
                    itmes.productAttribute.map(lsit=>{
                      if (lsit.attribute_id === this.productAttribute[i].attribute_id) {
                        lsit.product_attribute_name = this.productAttribute[i].product_attribute_name
                      }
                    })
                  }
                  if (typeof itmes.partsInPartsData === 'object') {
                    //循环子配件
                    itmes.partsInPartsData.map((itme2)=>{
                      if (typeof itme2.productAttribute === 'object' && itme2.sun === 0) {
                        itme2.productAttribute.map(lsit=>{
                          if (lsit.attribute_id === this.productAttribute[i].attribute_id) {
                            lsit.product_attribute_name = this.productAttribute[i].product_attribute_name
                          }
                        })
                      }
                      if (typeof itme2.sub_level_data === 'object') {
                        // 循环第三级配件
                        itme2.sub_level_data.map(itme3=>{
                          if (typeof itme3.attribute_data === 'object' && itme3.attribute_data !== null && itme3.sun === 0) {
                            itme3.attribute_data.map(lsit=>{
                              if (lsit.attribute_id === this.productAttribute[i].attribute_id) {
                                lsit.product_attribute_name = this.productAttribute[i].product_attribute_name
                              }
                            })
                          }
                          if (typeof itme3.sub_level_data === 'object') {
                            // 循环第四级配件
                            itme3.sub_level_data.map(itme4=>{
                              if (typeof itme4.attribute_data === 'object' && itme4.attribute_data !== null && itme4.sun === 0) {
                                itme4.attribute_data.map(lsit=>{
                                  if (lsit.attribute_id === this.productAttribute[i].attribute_id) {
                                    lsit.product_attribute_name = this.productAttribute[i].product_attribute_name
                                  }
                                })
                              }
                              if (typeof itme4.sub_level_data === 'object') {
                                // 循环第五级配件
                                itme4.sub_level_data.map(itme5=>{
                                  if (typeof itme5.attribute_data === 'object' && itme5.attribute_data !== null && itme5.sun === 0) {
                                    itme5.attribute_data.map(lsit=>{
                                      if (lsit.attribute_id === this.productAttribute[i].attribute_id) {
                                        lsit.product_attribute_name = this.productAttribute[i].product_attribute_name
                                      }
                                    })
                                  }
                                  if (typeof itme5.sub_level_data === 'object') {
                                    // 循环第六级配件
                                    itme5.sub_level_data.map(itme6=>{
                                      if (typeof itme6.attribute_data === 'object' && itme6.attribute_data !== null && itme6.sun === 0) {
                                        itme6.attribute_data.map(lsit=>{
                                          if (lsit.attribute_id === this.productAttribute[i].attribute_id) {
                                            lsit.product_attribute_name = this.productAttribute[i].product_attribute_name
                                          }
                                        })
                                      }
                                    })
                                  }
                                })
                              }
                            })
                          }
                        })
                      }
                    })
                  }
                })
              }
            }
            //同步产品和配件的属性后重新计算价格
            // this.onAccessoriesinput()
            // this.onAccessoriesinput2()
            // this.onAccessoriesinput3()
          },
          //隐藏和显示产品计算公式
          showcomputedbox(e){
            if (e.target.parentNode.style.height == '' || e.target.parentNode.style.height === '10px'){
              e.target.parentNode.style.height = 'auto'
            }
            else {
              e.target.parentNode.style.height = '10px'
            }
          },
          //主产品数量变化时重新计算配件的价格
          product_reduce_add(){
            if (typeof this.productAccessories === 'object'){
              //初始化配件
              this.productAccessories.map((itme)=>{
                //是否使用百分比计算配件价格
                if (itme.productAccessoriesPointType === '1' && !itme.composite_attribute_value){
                  itme.productAccessoriesPrice = Math.ceil((this.detail.result*this.num)*(itme.productAccessoriesPoint/100)).toFixed(2)
                  //配件价格改变,如果已选择则重新调用公式计算
                  if (itme.sun>0){
                    this.onAccessoriesinput(itme.Identification)
                  }
                }
                //初始化子配件
                if (typeof itme.partsInPartsData === 'object') {
                  itme.partsInPartsData.map((itme2)=>{
                    //是否使用百分比计算配件价格
                    if (itme2.productAccessoriesPointType === '1' && !itme2.composite_attribute_value){
                      itme2.productAccessoriesPrice = Math.ceil((this.detail.result*this.num)*(itme2.productAccessoriesPoint/100)).toFixed(2)
                      //配件价格改变,如果已选择则重新调用公式计算
                      if (itme2.sun>0){
                        this.onAccessoriesinput(itme2.Identification)
                      }
                    }
                    //初始化第三级配件
                    if (typeof itme2.sub_level_data === 'object') {
                      itme2.sub_level_data.map((itme3)=>{
                        //是否使用百分比计算配件价格
                        if (itme3.productAccessoriesPointType === '1' && !itme3.composite_attribute_value){
                          itme3.second_price = Math.ceil((this.detail.result*this.num)*(itme3.productAccessoriesPoint/100)).toFixed(2)
                          //配件价格改变,如果已选择则重新调用公式计算
                          if (itme3.sun>0){
                            this.onAccessoriesinput(itme3.Identification)
                          }
                        }
                        //初始化第四级配件
                        if (typeof itme3.sub_level_data === 'object') {
                          itme3.sub_level_data.map((itme4)=>{
                            //是否使用百分比计算配件价格
                            if (itme4.productAccessoriesPointType === '1' && !itme4.composite_attribute_value){
                              itme4.second_price = Math.ceil((this.detail.result*this.num)*(itme4.productAccessoriesPoint/100)).toFixed(2)
                              //配件价格改变,如果已选择则重新调用公式计算
                              if (itme4.sun>0){
                                this.onAccessoriesinput(itme4.Identification)
                              }
                            }
                            //初始化第五级配件
                            if (typeof itme4.sub_level_data === 'object') {
                              itme4.sub_level_data.map((itme5)=>{
                                //是否使用百分比计算配件价格
                                if (itme5.productAccessoriesPointType === '1' && !itme5.composite_attribute_value){
                                  itme5.second_price = Math.ceil((this.detail.result*this.num)*(itme5.productAccessoriesPoint/100)).toFixed(2)
                                  //配件价格改变,如果已选择则重新调用公式计算
                                  if (itme5.sun>0){
                                    this.onAccessoriesinput(itme5.Identification)
                                  }
                                }
                                //初始化第六级配件
                                if (typeof itme5.sub_level_data === 'object') {
                                  itme5.sub_level_data.map((itme6)=>{
                                    //是否使用百分比计算配件价格
                                    if (itme6.productAccessoriesPointType === '1' && !itme6.composite_attribute_value){
                                      itme6.second_price = Math.ceil((this.detail.result*this.num)*(itme6.productAccessoriesPoint/100)).toFixed(2)
                                      //配件价格改变,如果已选择则重新调用公式计算
                                      if (itme6.sun>0){
                                        this.onAccessoriesinput(itme6.Identification)
                                      }
                                    }
                                  })
                                }
                              })
                            }
                          })
                        }
                      })
                    }
                  })
                }
              })
            }
          },
          //选择配件
          onselect(Identification){
            // console.log(Identification)
            if (typeof this.productAccessories === 'object'){
              this.productAccessories.map((itme,i)=>{
                // 判断是否是第一级子配件
                if (Identification === itme.Identification){
                  if (itme.select === 'active') {
                    itme.select = ''
                    if (itme.product_name === this.showspartsname2) {
                      this.showsparts2 = []
                      this.showsparts3 = []
                      this.showsparts4 = []
                      this.showsparts5 = []
                      this.showsparts6 = []
                    }
                    this.productAccessories.splice(i,1,itme)
                  }
                  else {
                    itme.select = 'active'
                    this.onAccessoriesinput(Identification) //选中时计算产品价格
                    if (typeof itme.partsInPartsData === 'object'){
                      this.showsparts2 = itme.partsInPartsData
                      this.showspartsname2 = itme.product_name
                      this.showsparts3 = []
                    }
                    else {
                      this.showsparts2 = []
                      this.showsparts3 = []
                      this.showsparts4 = []
                      this.showsparts5 = []
                      this.showsparts6 = []
                    }
                    //清除子配件的选择状态
                    if (typeof itme.partsInPartsData === 'object'){
                      itme.partsInPartsData.map((itme)=>{
                        itme.select = ''
                        if (typeof itme.sub_level_data === 'object') {
                          // 循环第三级配件，清除第三级子配件的选择状态
                          itme.sub_level_data.map(itme2=>{
                            itme2.select = ''
                          })
                        }
                      })
                    }
                    if (Number.parseInt(itme.sun)===0) {
                      itme.sun = 1
                    }
                    this.productAccessories.splice(i,1,itme)
                    return;
                  }
                }
                else {
                  // 如果不是循环第二级子配件
                  if (typeof itme.partsInPartsData === 'object'){
                    itme.partsInPartsData.map((itme2)=>{
                      // 判断是不是二级配件
                      if (Identification === itme2.Identification){
                        if (itme2.select === 'active') {
                          itme2.select = ''
                          if (itme2.product_name === this.showspartsname3) {
                            this.showsparts3 = []
                            this.showsparts4 = []
                            this.showsparts5 = []
                            this.showsparts6 = []
                          }
                          this.productAccessories.splice(i,1,itme)
                        }
                        else {
                          itme2.select = 'active'
                          this.onAccessoriesinput(Identification) //选中时计算产品价格
                          if (typeof itme2.sub_level_data === 'object'){
                            this.showsparts3 = itme2.sub_level_data
                            this.showspartsname3 = itme2.product_name
                            this.showsparts4 = []
                          }
                          else {
                            this.showsparts3 = []
                            this.showsparts4 = []
                            this.showsparts5 = []
                            this.showsparts6 = []
                          }
                          //清除子配件的选择状态
                          if (typeof itme2.partsInPartsData === 'object'){
                            itme2.partsInPartsData.map((list)=>{
                              if (typeof list.sub_level_data === 'object') {
                                // 循环第三级配件，清除第三级子配件的选择状态
                                list.sub_level_data.map(list2=>{
                                  list2.select = ''
                                })
                              }
                            })
                          }
                          if (Number.parseInt(itme2.sun)===0) {
                            itme2.sun = 1
                          }
                          this.productAccessories.splice(i,1,itme)
                          return;
                        }
                      }
                      else {
                        // 循环第三级配件
                        if (typeof itme2.sub_level_data === 'object'){
                          itme2.sub_level_data.map((itme3)=>{
                            // 判断是不是三级配件
                            if (Identification === itme3.Identification){
                              if (itme3.select === 'active') {
                                itme3.select = ''
                                if (itme3.name === this.showspartsname4) {
                                  this.showsparts4 = []
                                  this.showsparts5 = []
                                  this.showsparts6 = []
                                }
                                this.productAccessories.splice(i,1,itme)
                              }
                              else {
                                itme3.select = 'active'
                                this.onAccessoriesinput(itme3.Identification) //选中时计算产品价格
                                if (typeof itme3.sub_level_data === 'object'){
                                  this.showsparts4 = itme3.sub_level_data
                                  this.showspartsname4 = itme3.name
                                  this.showsparts5 = []
                                }
                                else {
                                  this.showsparts4 = []
                                  this.showsparts5 = []
                                  this.showsparts6 = []
                                }

                                //清除子配件的选择状态
                                if (typeof itme3.sub_level_data === 'object'){
                                  itme3.sub_level_data.map((list)=>{
                                    if (typeof list.sub_level_data === 'object') {
                                      // 循环第三级配件，清除第三级子配件的选择状态
                                      list.sub_level_data.map(list2=>{
                                        list2.select = ''
                                      })
                                    }
                                  })
                                }
                                if (Number.parseInt(itme3.sun)===0) {
                                  itme3.sun = 1
                                }
                                this.productAccessories.splice(i,1,itme)
                                return;
                              }
                            }
                            else {
                              // 循环第四级配件
                              if (typeof itme3.sub_level_data === 'object'){
                                itme3.sub_level_data.map((itme4)=>{
                                  // 判断是不是四级配件
                                  if (Identification === itme4.Identification){
                                    if (itme4.select === 'active') {
                                      itme4.select = ''
                                      if (itme4.name === this.showspartsname5) {
                                        this.showsparts5 = []
                                        this.showsparts6 = []
                                      }
                                      this.productAccessories.splice(i,1,itme)
                                    }
                                    else {
                                      itme4.select = 'active'
                                      this.onAccessoriesinput(itme4.Identification) //选中时计算产品价格
                                      if (typeof itme4.sub_level_data === 'object'){
                                        this.showsparts5 = itme4.sub_level_data
                                        this.showspartsname5 = itme4.name
                                        this.showsparts6 = []
                                      }
                                      else {
                                        this.showsparts5 = []
                                        this.showsparts6 = []
                                      }
                                      //清除子配件的选择状态
                                      if (typeof itme4.sub_level_data === 'object'){
                                        itme4.sub_level_data.map((list)=>{
                                          if (typeof list.sub_level_data === 'object') {
                                            // 循环第三级配件，清除第三级子配件的选择状态
                                            list.sub_level_data.map(list2=>{
                                              list2.select = ''
                                            })
                                          }
                                        })
                                      }
                                      if (Number.parseInt(itme4.sun)===0) {
                                        itme4.sun = 1
                                      }
                                      this.productAccessories.splice(i,1,itme)
                                      return;
                                    }
                                  }
                                  else {
                                    // 循环第五级配件
                                    if (typeof itme4.sub_level_data === 'object'){
                                      itme4.sub_level_data.map((itme5)=>{
                                        // 判断是不是五级配件
                                        if (Identification === itme5.Identification){
                                          if (itme5.select === 'active') {
                                            itme5.select = ''
                                            if (itme5.name === this.showspartsname6) {
                                              this.showsparts6 = []
                                            }
                                            this.productAccessories.splice(i,1,itme)
                                          }
                                          else {
                                            itme5.select = 'active'
                                            this.onAccessoriesinput(itme5.Identification) //选中时计算产品价格
                                            if (typeof itme5.sub_level_data === 'object'){
                                              this.showsparts6 = itme5.sub_level_data
                                              this.showspartsname6 = itme5.name
                                            }
                                            else {
                                              this.showsparts6 = []
                                            }
                                            //清除子配件的选择状态
                                            if (typeof itme5.sub_level_data === 'object'){
                                              itme5.sub_level_data.map((list)=>{
                                                if (typeof list.sub_level_data === 'object') {
                                                  // 循环第三级配件，清除第三级子配件的选择状态
                                                  list.sub_level_data.map(list2=>{
                                                    list2.select = ''
                                                  })
                                                }
                                              })
                                            }
                                            if (Number.parseInt(itme5.sun)===0) {
                                              itme5.sun = 1
                                            }
                                            this.productAccessories.splice(i,1,itme)
                                            return;
                                          }
                                        }
                                        else {
                                          // 循环第六级配件
                                          if (typeof itme5.sub_level_data === 'object'){
                                            itme5.sub_level_data.map((itme6)=>{
                                              // 判断是不是第六级配件
                                              if (Identification === itme6.Identification){
                                                if (itme6.select === 'active') {
                                                  itme6.select = ''
                                                  if (itme6.name === this.showspartsname2) {
                                                    this.showsparts6 = []
                                                  }
                                                  this.productAccessories.splice(i,1,itme)
                                                }
                                                else {
                                                  itme6.select = 'active'
                                                  this.onAccessoriesinput(itme6.Identification) //选中时计算产品价格
                                                  // if (typeof itme6.sub_level_data === 'object'){
                                                  //   this.showsparts6 = itme6.sub_level_data
                                                  //   this.showspartsname6 = itme6.name
                                                  // }
                                                  // else {
                                                  //   this.showsparts6 = []
                                                  // }
                                                  //清除子配件的选择状态
                                                  // if (typeof itme6.sub_level_data === 'object'){
                                                  //   itme6.sub_level_data.map((list)=>{
                                                  //     if (typeof list.sub_level_data === 'object') {
                                                  //       // 循环第三级配件，清除第三级子配件的选择状态
                                                  //       list.sub_level_data.map(list2=>{
                                                  //         list2.select = ''
                                                  //       })
                                                  //     }
                                                  //   })
                                                  // }
                                                  if (Number.parseInt(itme6.sun)===0) {
                                                    itme6.sun = 1
                                                  }
                                                  this.productAccessories.splice(i,1,itme)
                                                  return;
                                                }
                                              }
                                              else {
                                                // 循环第七级配件

                                              }
                                            })
                                          }
                                        }
                                      })
                                    }
                                  }
                                })
                              }
                            }
                          })
                        }
                      }
                    })
                  }
                }
              })
            }
          },
          //添加配件数量
          onadd(Identification){
            if (typeof this.productAccessories === 'object'){
              this.productAccessories.map((itme,i)=>{
                // 判断是否是第一级配件
                if (Identification === itme.Identification){
                  itme.sun += 1
                  this.productAccessories.splice(i,1,itme)
                }
                else {
                  // 循环第二级配件
                  if (typeof itme.partsInPartsData === 'object'){
                    itme.partsInPartsData.map((itme2)=>{
                      // 判断是否是第二级的配件
                      if (itme2.Identification === Identification){
                        itme2.sun += 1
                        this.productAccessories.splice(i,1,itme)
                      }
                      else {
                        // 循环第三级配件
                        if (typeof itme2.sub_level_data === 'object') {
                          itme2.sub_level_data.map(itme3=>{
                            // 判断是否是第三级配件
                            if (itme3.Identification === Identification) {
                              itme3.sun += 1
                              this.productAccessories.splice(i,1,itme)
                            }
                            else {
                              // 循环第四级配件
                              if (typeof itme3.sub_level_data === 'object') {
                                itme3.sub_level_data.map(itme4=>{
                                  // 判断是否是第四级配件
                                  if (itme4.Identification === Identification) {
                                    itme4.sun += 1
                                    this.productAccessories.splice(i,1,itme)
                                  }
                                  else {
                                    // 循环第五级配件
                                    if (typeof itme4.sub_level_data === 'object') {
                                      itme4.sub_level_data.map(itme5=>{
                                        // 判断是否是第五级配件
                                        if (itme5.Identification === Identification) {
                                          itme5.sun += 1
                                          this.productAccessories.splice(i,1,itme)
                                        }
                                        else {
                                          // 循环第六级配件
                                          if (typeof itme5.sub_level_data === 'object') {
                                            itme5.sub_level_data.map(itme6=>{
                                              // 判断是否是第六级配件
                                              if (itme6.Identification === Identification) {
                                                itme6.sun += 1
                                                this.productAccessories.splice(i,1,itme)
                                              }
                                            })
                                          }
                                        }
                                      })
                                    }
                                  }
                                })
                              }
                            }
                          })
                        }
                      }
                    })
                  }

                }
              })
            }
          },
          //减少配件数量
          onreduce(Identification){
            if (typeof this.productAccessories === 'object'){
              this.productAccessories.map((itme,i)=>{
                // 判断是否是第一级配件
                if (Identification === itme.Identification){
                  if (itme.sun>1) {
                    itme.sun -= 1
                  }
                  else if (Number.parseInt(itme.sun)===1) {
                    itme.sun -= 1
                    itme.select = ''

                    if (itme.product_name === this.showspartsname2) {
                      this.showsparts2 = []
                      this.showsparts3 = []
                      this.showsparts4 = []
                      this.showsparts5 = []
                      this.showsparts6 = []
                    }
                    //清除子配件的选择状态
                    if (typeof itme.partsInPartsData === 'object'){
                      itme.partsInPartsData.map((itme2)=>{
                        itme2.select = ''
                        if (typeof itme2.sub_level_data === 'object') {
                          // 循环第三级配件，清除第三级子配件的选择状态
                          itme2.sub_level_data.map(list=>{
                            list.select = ''
                          })
                        }
                      })
                    }
                  }
                  this.productAccessories.splice(i,1,itme)
                }
                else {
                  // 循环第二级配件
                  if (typeof itme.partsInPartsData === 'object'){
                    itme.partsInPartsData.map((itme2)=>{
                      // 判断是不是第二级配件
                      if (itme2.Identification === Identification){
                        if (itme2.sun>1){
                          itme2.sun -= 1
                        }
                        else if (Number.parseInt(itme2.sun)===1) {
                          itme2.sun -= 1
                          itme2.select = ''
                          if (itme2.product_name === this.showspartsname3) {
                            this.showsparts3 = []
                            this.showsparts4 = []
                            this.showsparts5 = []
                            this.showsparts6 = []
                          }
                          if (typeof itme2.sub_level_data === 'object') {
                            // 循环第三级配件，清除第三级子配件的选择状态
                            itme2.sub_level_data.map(itme2=>{
                              itme2.select = ''
                            })
                          }
                        }
                      }
                      else {
                        // 循环第三级配件
                        if (typeof itme2.sub_level_data === 'object') {
                          itme2.sub_level_data.map(itme3=>{
                            // 判断是不是第三级配件
                            if (itme3.Identification === Identification) {
                              if (itme3.sun>1){
                                itme3.sun -= 1
                              }
                              else if (Number.parseInt(itme3.sun)===1) {
                                itme3.sun -= 1
                                itme3.select = ''
                                if (itme3.name === this.showspartsname4) {
                                  this.showsparts4 = []
                                  this.showsparts5 = []
                                  this.showsparts6 = []
                                }
                                if (typeof itme3.sub_level_data === 'object') {
                                  // 循环第三级配件，清除第三级子配件的选择状态
                                  itme2.sub_level_data.map(itme2=>{
                                    itme2.select = ''
                                  })
                                }
                              }
                            }
                            else {
                              // 循环第四级配件
                              if (typeof itme3.sub_level_data === 'object') {
                                itme3.sub_level_data.map(itme4=>{
                                  // 判断是不是第四级配件
                                  if (itme4.Identification === Identification) {
                                    if (itme4.sun>1){
                                      itme4.sun -= 1
                                    }
                                    else if (Number.parseInt(itme4.sun)===1) {
                                      itme4.sun -= 1
                                      itme4.select = ''
                                      if (itme4.name === this.showspartsname5) {
                                        this.showsparts5 = []
                                        this.showsparts6 = []
                                      }
                                      if (typeof itme4.sub_level_data === 'object') {
                                        // 循环第三级配件，清除第三级子配件的选择状态
                                        itme4.sub_level_data.map(itme2=>{
                                          itme2.select = ''
                                        })
                                      }
                                    }
                                  }
                                  else {
                                    // 循环第五级配件
                                    if (typeof itme4.sub_level_data === 'object') {
                                      itme4.sub_level_data.map(itme5=>{
                                        // 判断是不是第五级配件
                                        if (itme5.Identification === Identification) {
                                          if (itme5.sun>1){
                                            itme5.sun -= 1
                                          }
                                          else if (Number.parseInt(itme5.sun)===1) {
                                            itme5.sun -= 1
                                            itme5.select = ''
                                            if (itme5.name === this.showspartsname6) {
                                              this.showsparts6 = []
                                            }
                                            if (typeof itme5.sub_level_data === 'object') {
                                              // 循环第三级配件，清除第三级子配件的选择状态
                                              itme5.sub_level_data.map(itme2=>{
                                                itme2.select = ''
                                              })
                                            }
                                          }
                                        }
                                        else {
                                          // 循环第六级配件
                                          if (typeof itme5.sub_level_data === 'object') {
                                            itme5.sub_level_data.map(itme6=>{
                                              // 判断是不是第四级配件
                                              if (itme6.Identification === Identification) {
                                                if (itme6.sun>1){
                                                  itme6.sun -= 1
                                                }
                                                else if (Number.parseInt(itme6.sun)===1) {
                                                  itme6.sun -= 1
                                                  itme6.select = ''
                                                  if (typeof itme6.sub_level_data === 'object') {
                                                    // 循环第三级配件，清除第三级子配件的选择状态
                                                    itme6.sub_level_data.map(itme2=>{
                                                      itme2.select = ''
                                                    })
                                                  }
                                                }
                                              }
                                            })
                                          }
                                        }
                                      })
                                    }
                                  }
                                })
                              }
                            }
                          })
                        }
                      }
                    })
                    this.productAccessories.splice(i,1,itme)
                  }
                }
              })
            }
          },
          //配件的计算公式调用
          onAccessoriesinput(Identification){
            let obj={}
            if (typeof this.productAccessories === 'object') {
              this.productAccessories.map((itme,index)=>{
                // 判断是否是一级配件
                if (Identification === itme.Identification) {
                  // 配件的组合属性价格,没有组合属性id就请求接口，有就修改价格
                  if (itme.composite_attribute_value){
                    // 将价格修改为组合属性的价格
                    itme.AttributeGroup.map(list=>{
                      if (list.id === itme.composite_attribute_value){
                        itme.productAccessoriesPrice = list.attribute_group_price
                        // 同步组合属性和原属性
                        list.attribute_id_group.split(',').map((asttr,index)=>{
                          itme.productAttribute.map(prooattr=>{
                            if (asttr === prooattr.attribute_id) {
                              prooattr.product_attribute_name = list.attribute_value_group.split('×')[index]
                            }
                          })
                        })
                      }
                    })

                  }
                  else {
                    getProductAttributeGroupPrice(itme.product_id).then(data=>{
                      if (data.data){
                        itme.AttributeGroup = data.data
                        // 将组合属性中已经出现的属性禁止修改
                        let attribute_id_group = []
                        itme.AttributeGroup.map(Groupitme=>{
                          let a = Groupitme.attribute_id_group.split(',')
                          attribute_id_group = attribute_id_group.concat(a)
                        })
                        attribute_id_group = Array.from(new Set(attribute_id_group))
                        attribute_id_group.map(group_itme=>{
                          itme.productAttribute.map(list=>{
                            if (group_itme === list.attribute_id) {
                              list.disabled = true
                            }
                          })
                        })
                      }
                    })
                  }

                  if (typeof itme.productAttribute === 'object') {
                    obj.formula_id =itme.product_formula_id
                    obj.product_id =itme.product_id
                    obj.attr_id=itme.product_attribute_ids
                    for (let i=0;i<itme.productAttribute.length;i++){
                      //下拉框的选项为'() 或 （）'时变为输入框

                      if (itme.productAttribute[i].product_attribute_name=== '（）' || itme.productAttribute[i].product_attribute_name === '()'){
                        itme.productAttribute[i].product_attribute_name = ''
                        delete itme.productAttribute[i].attribute_list
                      }
                      if (itme.productAttribute[i].product_attribute_name === '') {
                        obj['formula_'+itme.productAttribute[i].attribute_id] = 0
                      }
                      //是计算属性才传入
                      else if (itme.productAttribute[i].in_formula===1) {
                        obj['formula_'+itme.productAttribute[i].attribute_id] = itme.productAttribute[i].product_attribute_name
                      }
                    }
                    productFormula(obj).then((data)=>{
                      if (data.status){
                        itme.result = data.info.result * itme.productAccessoriesPrice
                      }
                      else {
                        itme.result = 1 * itme.productAccessoriesPrice
                      }
                      this.$set(this.productAccessories,index,itme)
                    })
                  }
                  else {
                    itme.result = itme.productAccessoriesPrice
                  }
                }
                else {
                  // // 循环二级配件
                  if (typeof itme.partsInPartsData === 'object') {
                    itme.partsInPartsData.map((itme2)=>{
                      // 判断是否是二级配件
                      if (Identification === itme2.Identification) {
                        // 配件的组合属性价格,没有传组合属性id就请求接口，有就修改价格
                        if (itme2.composite_attribute_value){
                          itme2.AttributeGroup.map(list=>{
                            if (list.id === itme2.composite_attribute_value){
                              itme2.productAccessoriesPrice = list.attribute_group_price
                              // 同步组合属性和原属性
                              list.attribute_id_group.split(',').map((asttr,index)=>{
                                itme2.productAttribute.map(prooattr=>{
                                  if (asttr === prooattr.attribute_id) {
                                    prooattr.product_attribute_name = list.attribute_value_group.split('×')[index]
                                  }
                                })
                              })
                            }
                          })
                        }
                        else {
                          getProductAttributeGroupPrice(itme2.product_id).then(data=>{
                            if (data.data){
                              itme2.AttributeGroup = data.data
                              // 将组合属性中已经出现的属性禁止修改
                              let attribute_id_group = []
                              itme2.AttributeGroup.map(Groupitme=>{
                                let a = Groupitme.attribute_id_group.split(',')
                                attribute_id_group = attribute_id_group.concat(a)
                              })
                              attribute_id_group = Array.from(new Set(attribute_id_group))
                              attribute_id_group.map(group_itme=>{
                                itme2.productAttribute.map(list=>{
                                  if (group_itme === list.attribute_id) {
                                    list.disabled = true
                                  }
                                })
                              })
                            }
                          })
                        }
                        if (typeof itme2.productAttribute === 'object') {
                          obj.formula_id =itme2.product_formula_id
                          obj.product_id =itme2.product_id
                          obj.attr_id=itme2.product_attribute_ids
                          for (let i=0;i<itme2.productAttribute.length;i++){
                            //下拉框的选项为'() 或 （）'时变为输入框
                            if (itme2.productAttribute[i].product_attribute_name=== '（）' || itme2.productAttribute[i].product_attribute_name === '()'){
                              itme2.productAttribute[i].product_attribute_name = ''
                              delete itme2.productAttribute[i].attribute_list
                            }
                            if (itme2.productAttribute[i].product_attribute_name === '') {
                              obj['formula_'+itme2.productAttribute[i].attribute_id] = 0
                            }
                            //是计算属性才传入
                            else if (itme2.productAttribute[i].in_formula===1) {
                              obj['formula_'+itme2.productAttribute[i].attribute_id] = itme2.productAttribute[i].product_attribute_name
                            }
                          }
                          productFormula(obj).then((data)=>{
                            if (data.status){
                              itme2.result = data.info.result * itme2.productAccessoriesPrice
                            }
                            else {
                              itme2.result = 1 * itme2.productAccessoriesPrice
                            }
                            this.$set(this.productAccessories,index,itme)
                          })
                        }
                        else {
                          itme2.result = itme2.productAccessoriesPrice
                        }
                      }
                      else {
                        // 循环三级配件
                        if (typeof itme2.sub_level_data === 'object') {
                          itme2.sub_level_data.map((itme3)=>{
                            // 判断是否是三级配件
                            if (Identification === itme3.Identification) {
                              // 配件的组合属性价格,没有传组合属性id就请求接口，有就修改价格
                              if (itme3.composite_attribute_value){
                                itme3.AttributeGroup.map(list=>{
                                  if (list.id === itme3.composite_attribute_value){
                                    itme3.productAccessoriesPrice = list.attribute_group_price
                                    // 同步组合属性和原属性
                                    list.attribute_id_group.split(',').map((asttr,index)=>{
                                      itme3.attribute_data.map(prooattr=>{
                                        if (asttr === prooattr.attribute_id) {
                                          prooattr.product_attribute_name = list.attribute_value_group.split('×')[index]
                                        }
                                      })
                                    })
                                  }
                                })
                              }
                              else {
                                getProductAttributeGroupPrice(itme3.product_id).then(data=>{
                                  if (data.data){
                                    itme3.AttributeGroup = data.data
                                    // 将组合属性中已经出现的属性禁止修改
                                    let attribute_id_group = []
                                    itme3.AttributeGroup.map(Groupitme=>{
                                      let a = Groupitme.attribute_id_group.split(',')
                                      attribute_id_group = attribute_id_group.concat(a)
                                    })
                                    attribute_id_group = Array.from(new Set(attribute_id_group))
                                    attribute_id_group.map(group_itme=>{
                                      itme3.attribute_data.map(list=>{
                                        if (group_itme === list.attribute_id) {
                                          list.disabled = true
                                        }
                                      })
                                    })

                                  }
                                })
                              }
                              if (typeof itme3.attribute_data === 'object') {
                                obj.formula_id =itme3.formula_id
                                obj.product_id =itme3.self_id
                                obj.attr_id=itme3.productattribute_ids
                                for (let i=0;i<itme3.attribute_data.length;i++){
                                  //下拉框的选项为'() 或 （）'时变为输入框
                                  if (itme3.attribute_data[i].product_attribute_name=== '（）' || itme3.attribute_data[i].product_attribute_name === '()'){
                                    itme3.attribute_data[i].product_attribute_name = ''
                                    delete itme3.attribute_data[i].attribute_list
                                  }
                                  if (itme3.attribute_data[i].product_attribute_name === '') {
                                    obj['formula_'+itme3.attribute_data[i].attribute_id] = 0
                                  }
                                  //是计算属性才传入
                                  else if (itme3.attribute_data[i].in_formula===1) {
                                    obj['formula_'+itme3.attribute_data[i].attribute_id] = itme3.attribute_data[i].product_attribute_name
                                  }
                                }
                                productFormula(obj).then((data)=>{
                                  if (data.status){
                                    itme3.result = data.info.result * itme3.second_price
                                  }
                                  else {
                                    itme3.result = 1 * itme3.second_price
                                  }
                                  this.$set(this.productAccessories,index,itme)
                                })
                              }
                              else {
                                itme3.result = itme3.second_price
                              }
                            }
                            else {
                              // 循环第四级配件
                              if (typeof itme3.sub_level_data === 'object') {
                                itme3.sub_level_data.map((itme4)=>{
                                  // 判断是否是四级配件
                                  if (Identification === itme4.Identification) {
                                    // 配件的组合属性价格,没有传组合属性id就请求接口，有就修改价格
                                    if (itme4.composite_attribute_value){
                                      itme4.AttributeGroup.map(list=>{
                                        if (list.id === itme4.composite_attribute_value){
                                          itme4.productAccessoriesPrice = list.attribute_group_price
                                          // 同步组合属性和原属性
                                          list.attribute_id_group.split(',').map((asttr,index)=>{
                                            itme4.attribute_data.map(prooattr=>{
                                              if (asttr === prooattr.attribute_id) {
                                                prooattr.product_attribute_name = list.attribute_value_group.split('×')[index]
                                              }
                                            })
                                          })
                                        }
                                      })
                                    }
                                    else {
                                      getProductAttributeGroupPrice(itme4.product_id).then(data=>{
                                        if (data.data){
                                          itme4.AttributeGroup = data.data
                                          // 将组合属性中已经出现的属性禁止修改
                                          let attribute_id_group = []
                                          itme4.AttributeGroup.map(Groupitme=>{
                                            let a = Groupitme.attribute_id_group.split(',')
                                            attribute_id_group = attribute_id_group.concat(a)
                                          })
                                          attribute_id_group = Array.from(new Set(attribute_id_group))
                                          attribute_id_group.map(group_itme=>{
                                            itme4.attribute_data.map(list=>{
                                              if (group_itme === list.attribute_id) {
                                                list.disabled = true
                                              }
                                            })
                                          })
                                        }
                                      })
                                    }
                                    if (typeof itme4.attribute_data === 'object') {
                                      obj.formula_id =itme4.formula_id
                                      obj.product_id =itme4.self_id
                                      obj.attr_id=itme4.productattribute_ids
                                      for (let i=0;i<itme4.attribute_data.length;i++){
                                        //下拉框的选项为'() 或 （）'时变为输入框
                                        if (itme4.attribute_data[i].product_attribute_name=== '（）' || itme4.attribute_data[i].product_attribute_name === '()'){
                                          itme4.attribute_data[i].product_attribute_name = ''
                                          delete itme4.attribute_data[i].attribute_list
                                        }
                                        if (itme4.attribute_data[i].product_attribute_name === '') {
                                          obj['formula_'+itme4.attribute_data[i].attribute_id] = 0
                                        }
                                        //是计算属性才传入
                                        else if (itme4.attribute_data[i].in_formula===1) {
                                          obj['formula_'+itme4.attribute_data[i].attribute_id] = itme4.attribute_data[i].product_attribute_name
                                        }
                                      }
                                      productFormula(obj).then((data)=>{
                                        if (data.status){
                                          itme4.result = data.info.result * itme4.second_price
                                        }
                                        else {
                                          itme4.result = 1 * itme4.second_price
                                        }
                                        this.$set(this.productAccessories,index,itme)
                                      })
                                    }
                                    else {
                                      itme4.result = itme4.second_price
                                    }
                                  }
                                  else {
                                    // 循环第五级配件
                                    if (typeof itme4.sub_level_data === 'object') {
                                      itme4.sub_level_data.map((itme5)=>{
                                        // 判断是否是五级配件
                                        if (Identification === itme5.Identification) {
                                          // 配件的组合属性价格,没有传组合属性id就请求接口，有就修改价格
                                          if (itme5.composite_attribute_value){
                                            itme5.AttributeGroup.map(list=>{
                                              if (list.id === itme5.composite_attribute_value){
                                                itme5.productAccessoriesPrice = list.attribute_group_price
                                                // 同步组合属性和原属性
                                                list.attribute_id_group.split(',').map((asttr,index)=>{
                                                  itme5.attribute_data.map(prooattr=>{
                                                    if (asttr === prooattr.attribute_id) {
                                                      prooattr.product_attribute_name = list.attribute_value_group.split('×')[index]
                                                    }
                                                  })
                                                })
                                              }
                                            })
                                          }
                                          else {
                                            getProductAttributeGroupPrice(itme5.product_id).then(data=>{
                                              if (data.data){
                                                itme5.AttributeGroup = data.data
                                                // 将组合属性中已经出现的属性禁止修改
                                                let attribute_id_group = []
                                                itme5.AttributeGroup.map(Groupitme=>{
                                                  let a = Groupitme.attribute_id_group.split(',')
                                                  attribute_id_group = attribute_id_group.concat(a)
                                                })
                                                attribute_id_group = Array.from(new Set(attribute_id_group))
                                                attribute_id_group.map(group_itme=>{
                                                  itme5.attribute_data.map(list=>{
                                                    if (group_itme === list.attribute_id) {
                                                      list.disabled = true
                                                    }
                                                  })
                                                })
                                              }
                                            })
                                          }
                                          if (typeof itme5.attribute_data === 'object') {
                                            obj.formula_id =itme5.formula_id
                                            obj.product_id =itme5.Identification
                                            obj.attr_id=itme5.productattribute_ids
                                            for (let i=0;i<itme5.attribute_data.length;i++){
                                              //下拉框的选项为'() 或 （）'时变为输入框
                                              if (itme5.attribute_data[i].product_attribute_name=== '（）' || itme5.attribute_data[i].product_attribute_name === '()'){
                                                itme5.attribute_data[i].product_attribute_name = ''
                                                delete itme5.attribute_data[i].attribute_list
                                              }
                                              if (itme5.attribute_data[i].product_attribute_name === '') {
                                                obj['formula_'+itme5.attribute_data[i].attribute_id] = 0
                                              }
                                              //是计算属性才传入
                                              else if (itme5.attribute_data[i].in_formula===1) {
                                                obj['formula_'+itme5.attribute_data[i].attribute_id] = itme5.attribute_data[i].product_attribute_name
                                              }
                                            }
                                            productFormula(obj).then((data)=>{
                                              if (data.status){
                                                itme5.result = data.info.result * itme5.second_price
                                              }
                                              else {
                                                itme5.result = 1 * itme5.second_price
                                              }
                                              this.$set(this.productAccessories,index,itme)
                                            })
                                          }
                                          else {
                                            itme5.result = itme5.second_price
                                          }
                                        }
                                        else {
                                          // 循环第六级配件
                                          if (typeof itme5.sub_level_data === 'object') {
                                            itme5.sub_level_data.map((itme6)=>{
                                              // 判断是否是五级配件
                                              if (Identification === itme6.Identification) {
                                                // 配件的组合属性价格,没有传组合属性id就请求接口，有就修改价格
                                                if (itme6.composite_attribute_value){
                                                  itme6.AttributeGroup.map(list=>{
                                                    if (list.id === itme6.composite_attribute_value){
                                                      itme6.productAccessoriesPrice = list.attribute_group_price
                                                      // 同步组合属性和原属性
                                                      list.attribute_id_group.split(',').map((asttr,index)=>{
                                                        itme6.attribute_data.map(prooattr=>{
                                                          if (asttr === prooattr.attribute_id) {
                                                            prooattr.product_attribute_name = list.attribute_value_group.split('×')[index]
                                                          }
                                                        })
                                                      })
                                                    }
                                                  })
                                                }
                                                else {
                                                  getProductAttributeGroupPrice(itme6.product_id).then(data=>{
                                                    if (data.data){
                                                      itme6.AttributeGroup = data.data
                                                      // 将组合属性中已经出现的属性禁止修改
                                                      let attribute_id_group = []
                                                      itme6.AttributeGroup.map(Groupitme=>{
                                                        let a = Groupitme.attribute_id_group.split(',')
                                                        attribute_id_group = attribute_id_group.concat(a)
                                                      })
                                                      attribute_id_group = Array.from(new Set(attribute_id_group))
                                                      attribute_id_group.map(group_itme=>{
                                                        itme6.attribute_data.map(list=>{
                                                          if (group_itme === list.attribute_id) {
                                                            list.disabled = true
                                                          }
                                                        })
                                                      })
                                                    }
                                                  })
                                                }
                                                if (typeof itme6.attribute_data === 'object') {
                                                  obj.formula_id =itme6.formula_id
                                                  obj.product_id =itme6.self_id
                                                  obj.attr_id=itme6.productattribute_ids
                                                  for (let i=0;i<itme6.attribute_data.length;i++){
                                                    //下拉框的选项为'() 或 （）'时变为输入框
                                                    if (itme6.attribute_data[i].product_attribute_name=== '（）' || itme6.attribute_data[i].product_attribute_name === '()'){
                                                      itme6.attribute_data[i].product_attribute_name = ''
                                                      delete itme6.attribute_data[i].attribute_list
                                                    }
                                                    if (itme6.attribute_data[i].product_attribute_name === '') {
                                                      obj['formula_'+itme6.attribute_data[i].attribute_id] = 0
                                                    }
                                                    //是计算属性才传入
                                                    else if (itme6.attribute_data[i].in_formula===1) {
                                                      obj['formula_'+itme6.attribute_data[i].attribute_id] = itme6.attribute_data[i].product_attribute_name
                                                    }
                                                  }
                                                  productFormula(obj).then((data)=>{
                                                    if (data.status){
                                                      itme6.result = data.info.result * itme6.second_price
                                                    }
                                                    else {
                                                      itme6.result = 1 * itme6.second_price
                                                    }
                                                    this.$set(this.productAccessories,index,itme)
                                                  })
                                                }
                                                else {
                                                  itme6.result = itme6.second_price
                                                }
                                              }
                                              else {
                                                // 循环第七级配件
                                              }
                                            })
                                          }
                                        }
                                      })
                                    }
                                  }
                                })
                              }
                            }
                          })
                        }
                      }
                    })
                  }
                }
              })
            }

          },
          // 配件的数值范围限制
          onattributeSizerange(Identification,attribute_id,min,max){
            if (typeof this.productAccessories === 'object'){
              this.productAccessories.map((itme)=>{
                // 判断是不是第一级配件
                if (Identification === itme.Identification) {
                  itme.productAttribute.map((itme)=>{
                    if (itme.attribute_id === attribute_id) {
                      if(min && itme.product_attribute_name < min){
                        itme.product_attribute_name = min
                        //变为指定的范围值时调用公式计算重新计算
                        this.onAccessoriesinput(Identification)
                      }
                      else if (max && itme.product_attribute_name > max) {
                        itme.product_attribute_name = max
                        //变为指定的范围值时调用公式计算重新计算
                        this.onAccessoriesinput(Identification)
                      }
                    }
                  })
                }
                else {
                  // 循环第二级配件
                  if (typeof itme.partsInPartsData === 'object'){
                    itme.partsInPartsData.map((itme2)=>{
                      // 判断是不是第二级配件
                      if (Identification === itme2.Identification) {
                        itme2.productAttribute.map((itme3)=>{
                          if (itme3.attribute_id === attribute_id) {
                            if(min && itme3.product_attribute_name < min){
                              itme3.product_attribute_name = min
                              //变为指定的范围值时调用公式计算重新计算
                              this.onAccessoriesinput(Identification)
                            }
                            else if (max && itme3.product_attribute_name > max) {
                              itme3.product_attribute_name = max
                              //变为指定的范围值时调用公式计算重新计算
                              this.onAccessoriesinput(Identification)
                            }
                          }
                        })
                      }
                      else {
                        // 循环第三级配件
                        if (typeof itme2.sub_level_data === 'object'){
                          itme2.sub_level_data.map((itme3)=>{
                            // 判断是不是第三级配件
                            if (Identification === itme3.Identification) {
                              itme3.attribute_data.map((list)=>{
                                if (list.attribute_id === attribute_id) {
                                  if(min && list.product_attribute_name < min){
                                    list.product_attribute_name = min
                                    //变为指定的范围值时调用公式计算重新计算
                                    this.onAccessoriesinput(Identification)
                                  }
                                  else if (max && list.product_attribute_name > max) {
                                    list.product_attribute_name = max
                                    //变为指定的范围值时调用公式计算重新计算
                                    this.onAccessoriesinput(Identification)
                                  }
                                }
                              })
                            }
                            else {
                              // 循环第四级配件
                              if (typeof itme3.sub_level_data === 'object'){
                                itme3.sub_level_data.map((itme4)=>{
                                  // 判断是不是第四级配件
                                  if (Identification === itme4.Identification) {
                                    itme4.attribute_data.map((list)=>{
                                      if (list.attribute_id === attribute_id) {
                                        if(min && list.product_attribute_name < min){
                                          list.product_attribute_name = min
                                          //变为指定的范围值时调用公式计算重新计算
                                          this.onAccessoriesinput(Identification)
                                        }
                                        else if (max && list.product_attribute_name > max) {
                                          list.product_attribute_name = max
                                          //变为指定的范围值时调用公式计算重新计算
                                          this.onAccessoriesinput(Identification)
                                        }
                                      }
                                    })
                                  }
                                  else {
                                    // 循环第五级配件
                                    if (typeof itme4.sub_level_data === 'object'){
                                      itme4.sub_level_data.map((itme5)=>{
                                        // 判断是不是第五级配件
                                        if (Identification === itme5.Identification) {
                                          itme5.attribute_data.map((list)=>{
                                            if (list.attribute_id === attribute_id) {
                                              if(min && list.product_attribute_name < min){
                                                list.product_attribute_name = min
                                                //变为指定的范围值时调用公式计算重新计算
                                                this.onAccessoriesinput(Identification)
                                              }
                                              else if (max && list.product_attribute_name > max) {
                                                list.product_attribute_name = max
                                                //变为指定的范围值时调用公式计算重新计算
                                                this.onAccessoriesinput(Identification)
                                              }
                                            }
                                          })
                                        }
                                        else {
                                          // 循环第六级配件
                                          if (typeof itme5.sub_level_data === 'object'){
                                            itme5.sub_level_data.map((itme6)=>{
                                              // 判断是不是第六级配件
                                              if (Identification === itme6.Identification) {
                                                itme6.attribute_data.map((list)=>{
                                                  if (list.attribute_id === attribute_id) {
                                                    if(min && list.product_attribute_name < min){
                                                      list.product_attribute_name = min
                                                      //变为指定的范围值时调用公式计算重新计算
                                                      this.onAccessoriesinput(Identification)
                                                    }
                                                    else if (max && list.product_attribute_name > max) {
                                                      list.product_attribute_name = max
                                                      //变为指定的范围值时调用公式计算重新计算
                                                      this.onAccessoriesinput(Identification)
                                                    }
                                                  }
                                                })
                                              }
                                              else {
                                                // 循环第七级配件
                                              }
                                            })
                                          }
                                        }
                                      })
                                    }
                                  }
                                })
                              }
                            }
                          })
                        }
                      }
                    })
                  }
                }
              })
            }
          },
          // 选择配件的组合属性价格
          CompositeAttribute(id){
            console.log()
          },

          //加入购物车
          onmessagebox(){
            this.detail.formula_handle = []
            this.detail.attributeData  = []
            this.detail.partsData = []
            this.detail.remarks = this.remarks
            this.detail.installation = localStorage.getItem('installation')
            this.detail.warehouse_name = localStorage.getItem('Installationlocation')
            this.detail.unit_price = this.total

            let arr = []
            this.productAttribute.map((itme)=>{
              arr.push(itme)
              // if (!itme.attribute_list) {
              //
              // }
              this.detail.formula_handle.push([itme.product_attribute_name_title]+':'+itme.product_attribute_name.toString().replace(/\,/g,"，"))
              this.detail.attributeData.push({
                attribute_id:itme.attribute_id,
                attribute_value:itme.product_attribute_name,
                type:itme.attribute_list?1:0,
              })
            })
            //如果属性为空，传空字符
            if (this.detail.formula_handle.length===0){
              this.detail.formula_handle = ''
            }
            //存储上次选择的值
            this.$store.commit('set_defaultAttributeValue',arr)
            // console.log(this.detail)
            if(typeof this.productAccessories === 'object'){
              this.productAccessories.map((itme)=>{
                //获取选中的配件 数量大于0
                if (itme.sun > 0) {

                  let partsInPartsData = []
                  if (typeof itme.partsInPartsData  === 'object') {
                    itme.partsInPartsData.map((list)=>{
                      //获取被选中的二级配件  数量大于0
                      if (list.sun > 0) {
                        //三级配件
                        let childpartsInPartsData = []
                        if (typeof list.sub_level_data  === 'object') {
                          list.sub_level_data.map((childlist)=>{
                            //获取被选中的三级配件  数量大于0
                            if (childlist.sun > 0) {
                              //获取三级配件选中的属性
                              let childpartsInPartsData4 = []
                              if (typeof childlist.sub_level_data  === 'object') {
                                childlist.sub_level_data.map((childlist4)=>{
                                  //获取被选中的第四级配件  数量大于0
                                  if (childlist4.sun > 0) {
                                    // 五级配件
                                    let childpartsInPartsData5 = []
                                    if (typeof childlist4.sub_level_data  === 'object') {
                                      childlist4.sub_level_data.map((childlist6)=>{
                                        //获取被选中的第五级配件  数量大于0
                                        if (childlist6.sun > 0) {
                                          let childpartsInPartsData6 = []
                                          if (typeof childlist6.sub_level_data  === 'object') {
                                            childlist6.sub_level_data.map((childlist7)=>{
                                              //获取被选中的第六级配件  数量大于0
                                              if (childlist7.sun > 0) {
                                                //获取六级配件选中的属性
                                                let childformula_handle = []
                                                let attributeData = []
                                                if(typeof childlist7.attribute_data === 'object'){
                                                  childlist7.attribute_data.map((list2)=>{
                                                    childformula_handle.push([list2.product_attribute_name_title]+':'+list2.product_attribute_name.toString().replace(/\,/g,"，"))
                                                    attributeData.push({
                                                      attribute_id:list2.attribute_id,
                                                      attribute_value:list2.product_attribute_name,
                                                      type:list2.attribute_list?1:0,
                                                    })
                                                  })
                                                }
                                                //六级级配件
                                                childpartsInPartsData6.push({
                                                  'product_id':childlist7.self_id,
                                                  'attribute_group_id':childlist7.composite_attribute_value,
                                                  'attribute_group_price':childlist7.productAccessoriesPrice,
                                                  'parts_name':childlist7.name,
                                                  'product_description':childlist7.description,
                                                  'product_description_en':childlist7.product_description_en,
                                                  'product_model':childlist7.model,
                                                  'product_installation_charge':childlist7.installation_charge,
                                                  'product_formula_id':childlist7.product_formula_id,
                                                  'totalquantity':childlist7.sun,
                                                  'parts_formula_result_value':childlist7.result,
                                                  'currency_symbol':childlist7.installation_charge_currency_symbol,
                                                  'formula_handle':childformula_handle.length>0?childformula_handle:'',
                                                  'attributeData':attributeData,
                                                  'productid':this.detail.product_id,
                                                })
                                              }
                                            })
                                          }
                                          //获取五级配件选中的属性
                                          let childformula_handle = []
                                          let attributeData = []
                                          if(typeof childlist6.attribute_data === 'object'){
                                            childlist6.attribute_data.map((list2)=>{
                                              childformula_handle.push([list2.product_attribute_name_title]+':'+list2.product_attribute_name.toString().replace(/\,/g,"，"))
                                              attributeData.push({
                                                attribute_id:list2.attribute_id,
                                                attribute_value:list2.product_attribute_name,
                                                type:list2.attribute_list?1:0,
                                              })
                                            })
                                          }
                                          //五级级配件
                                          childpartsInPartsData5.push({
                                            'product_id':childlist6.self_id,
                                            'attribute_group_id':childlist6.composite_attribute_value,
                                            'attribute_group_price':childlist6.productAccessoriesPrice,
                                            'parts_name':childlist6.name,
                                            'product_description':childlist6.description,
                                            'product_description_en':childlist6.product_description_en,
                                            'product_model':childlist6.model,
                                            'product_installation_charge':childlist6.installation_charge,
                                            'product_formula_id':childlist6.product_formula_id,
                                            'totalquantity':childlist6.sun,
                                            'parts_formula_result_value':childlist6.result,
                                            'currency_symbol':childlist6.installation_charge_currency_symbol,
                                            'formula_handle':childformula_handle.length>0?childformula_handle:'',
                                            'attributeData':attributeData,
                                            'partsInPartsData':childpartsInPartsData6,
                                            'productid':this.detail.product_id,
                                          })
                                        }
                                      })
                                    }
                                    //获取四级配件选中的属性
                                    let childformula_handle = []
                                    let attributeData = []
                                    if(typeof childlist4.attribute_data === 'object'){
                                      childlist4.attribute_data.map((list2)=>{
                                        childformula_handle.push([list2.product_attribute_name_title]+':'+list2.product_attribute_name.toString().replace(/\,/g,"，"))
                                        attributeData.push({
                                          attribute_id:list2.attribute_id,
                                          attribute_value:list2.product_attribute_name,
                                          type:list2.attribute_list?1:0,
                                        })
                                      })
                                    }
                                    //四级级配件
                                    childpartsInPartsData4.push({
                                      'product_id':childlist4.self_id,
                                      'attribute_group_id':childlist4.composite_attribute_value,
                                      'attribute_group_price':childlist4.productAccessoriesPrice,
                                      'parts_name':childlist4.name,
                                      'product_description':childlist4.description,
                                      'product_description_en':childlist4.product_description_en,
                                      'product_model':childlist4.model,
                                      'product_installation_charge':childlist4.installation_charge,
                                      'product_formula_id':childlist4.product_formula_id,
                                      'totalquantity':childlist4.sun,
                                      'parts_formula_result_value':childlist4.result,
                                      'currency_symbol':childlist4.installation_charge_currency_symbol,
                                      'formula_handle':childformula_handle.length>0?childformula_handle:'',
                                      'attributeData':attributeData,
                                      'partsInPartsData':childpartsInPartsData5,
                                      'productid':this.detail.product_id,
                                    })
                                  }
                                })
                              }

                              let childformula_handle = []
                              let attributeData = []
                              if(typeof childlist.attribute_data === 'object'){
                                childlist.attribute_data.map((list2)=>{
                                  childformula_handle.push([list2.product_attribute_name_title]+':'+list2.product_attribute_name.toString().replace(/\,/g,"，"))
                                  attributeData.push({
                                    attribute_id:list2.attribute_id,
                                    attribute_value:list2.product_attribute_name,
                                    type:list2.attribute_list?1:0,
                                  })
                                })
                              }
                              //三级级配件
                              childpartsInPartsData.push({
                                'product_id':childlist.self_id,
                                'attribute_group_id':childlist.composite_attribute_value,
                                'attribute_group_price':childlist.productAccessoriesPrice,
                                'parts_name':childlist.name,
                                'product_description':childlist.description,
                                'product_description_en':childlist.product_description_en,
                                'product_model':childlist.model,
                                'product_installation_charge':childlist.installation_charge,
                                'product_formula_id':childlist.product_formula_id,
                                'totalquantity':childlist.sun,
                                'parts_formula_result_value':childlist.result,
                                'currency_symbol':childlist.installation_charge_currency_symbol,
                                'formula_handle':childformula_handle.length>0?childformula_handle:'',
                                'attributeData':attributeData,
                                'partsInPartsData':childpartsInPartsData4,
                                'productid':this.detail.product_id,
                              })
                            }
                          })
                        }
                        //获取子配件选中的属性
                        let childformula_handle = []
                        let attributeData = []

                        if(typeof list.productAttribute === 'object'){
                          list.productAttribute.map((list2)=>{
                            childformula_handle.push([list2.product_attribute_name_title]+':'+list2.product_attribute_name.toString().replace(/\,/g,"，"))
                            attributeData.push({
                              attribute_id:list2.attribute_id,
                              attribute_value:list2.product_attribute_name,
                              type:list2.attribute_list?1:0,
                            })
                          })
                        }
                        //二级配件
                        partsInPartsData.push({
                          'product_id':list.product_id,
                          'attribute_group_id':list.composite_attribute_value,
                          'attribute_group_price':list.productAccessoriesPrice,
                          'parts_name':list.product_name,
                          'product_description':list.product_description,
                          'product_description_en':list.product_description_en,
                          'product_model':list.product_model,
                          'product_installation_charge':list.product_installation_charge,
                          'product_formula_id':list.product_formula_id,
                          'totalquantity':list.sun,
                          'parts_formula_result_value':list.result,
                          'currency_symbol':list.currency_symbol,
                          'formula_handle':childformula_handle.length>0?childformula_handle:'',
                          'attributeData':attributeData,
                          'partsInPartsData':childpartsInPartsData,
                          'productid':this.detail.product_id,
                        })

                      }
                    })
                  }
                  let formula_handle = []
                  let attributeData = []
                  //被选中的配件属性
                  if(typeof itme.productAttribute === 'object'){
                    itme.productAttribute.map((list)=>{
                      formula_handle.push([list.product_attribute_name_title]+':'+list.product_attribute_name.toString().replace(/\,/g,"，"))
                      attributeData.push({
                        attribute_id:list.attribute_id,
                        attribute_value:list.product_attribute_name,
                        type:list.attribute_list?1:0,
                      })
                    })
                  }
                  itme.expend_price=itme.productAccessoriesPrice
                  itme.Parentid=this.detail.product_id
                  //一级配件
                  this.detail.partsData.push({
                    'product_id':itme.product_id,
                    'attribute_group_id':itme.composite_attribute_value,
                    'attribute_group_price':itme.productAccessoriesPrice,
                    'parts_name':itme.product_name,
                    'product_description':itme.product_description,
                    'product_description_en':itme.product_description_en,
                    'product_installation_charge':itme.product_installation_charge,
                    'product_formula_id':itme.product_formula_id,
                    'totalquantity':itme.sun,
                    'parts_formula_result_value':itme.result,
                    'formula_handle':formula_handle.length>0?formula_handle:'',
                    'attributeData':attributeData,
                    'currency_symbol':itme.currency_symbol,
                    'productid':this.detail.product_id,
                    'partsInPartsData':partsInPartsData,
                  })
                  // LocalShoppingCart(itme.product_id,itme.sun,itme.product_id,itme)
                }
              })
            }
            LocalShoppingCart(this.detail.product_id,this.num,this.detail.expend_id,this.detail)
            if (this.$store.state.client){
              MessageBox({
                title: '提示',
                message: '是否繼續添加商品?',
                showCancelButton: true
              }).then((v)=>{
                if (v === 'confirm') {
                  this.$router.push({ path: '/index'});
                }
                else {
                  this.$router.push({ path: '/shoppingcart?id='+this.$route.query.id+'&product_id='+this.$route.query.product_id});
                }
              });
            }
            else {
              this.$confirm('是否繼續添加商品?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                distinguishCancelAndClose: true,
                type: 'success'
              }).then(() => {
                this.$router.push({ path: '/index'});
              }).catch((c) => {
                if (c==='cancel'){
                  this.$router.push({ path: '/shoppingcart?id='+this.$route.query.id+'&product_id='+this.$route.query.product_id});
                }
              });
            }
          },
        },
        computed:{
          total(){
            let totalall = 0
            let a = this.productAccessories
            for(let i=0;i<a.length;i++){
              if (a[i].sun > 0) {
                //计算选中的配件价格
                totalall += (a[i].sun * a[i].result) + ( a[i].sun*a[i].product_installation_charge)
                if (typeof a[i].partsInPartsData === 'object'){
                  a[i].partsInPartsData.map((itme)=>{
                    if (itme.sun > 0){
                      //计算选中的子配件价格
                      // console.log(itme.result)
                      totalall += (itme.sun * itme.result) + ( itme.sun*itme.product_installation_charge)
                      if (typeof itme.sub_level_data === 'object'){
                        itme.sub_level_data.map((itme3)=>{
                          if (itme3.sun > 0){
                            //计算选中的第三级配件价格
                            totalall += (itme3.sun * itme3.result) + ( itme3.sun*itme3.installation_charge)
                            if (typeof itme3.sub_level_data === 'object'){
                              itme3.sub_level_data.map((itme4)=>{
                                if (itme4.sun > 0){
                                  //计算选中的第四级配件价格
                                  totalall += (itme4.sun * itme4.result) + ( itme4.sun*itme4.installation_charge)
                                  if (typeof itme4.sub_level_data === 'object'){
                                    itme4.sub_level_data.map((itme5)=>{
                                      if (itme5.sun > 0){
                                        //计算选中的第五级配件价格
                                        totalall += (itme5.sun * itme5.result) + ( itme5.sun*itme5.installation_charge)
                                        if (typeof itme5.sub_level_data === 'object'){
                                          itme5.sub_level_data.map((itme6)=>{
                                            if (itme6.sun > 0){
                                              //计算选中的第六级配件价格
                                              totalall += (itme6.sun * itme6.result) + ( itme6.sun*itme6.installation_charge)
                                            }
                                          })
                                        }
                                      }
                                    })
                                  }
                                }
                              })
                            }
                          }
                        })
                      }
                    }
                  })
                }
              }
            }
            totalall += (this.detail.result*this.num) + (this.num*this.detail.product_installation_charge)
            return totalall.toFixed(2)
          },
        }
    }
</script>

<style lang="less">
  @import "../assets/less/base";
  .popper-class.el-select{
    color: transparent;
    width: 28px !important;
    min-height: 28px;
    border-radius: 50%;
    margin-bottom: 0;
    margin-left: 0;
    .el-select-dropdown{
      background-color: transparent !important;
    }
    >.el-input{
      margin-bottom: 0 !important;
      width: auto;
      margin-left: 0;
      input{
        background: transparent;
        color: transparent;
        width: 28px !important;
        height: 28px;
        border-radius: 50%;
        padding: 0;
        border: none;
      }
      .el-input__suffix{
        display: none;
      }
    }
    .el-input__inner{
      /*border: none;*/
    }
  }
  .selectitme{
    color: transparent !important;
    border-radius: 50%;
    padding: 0 !important;
    margin-top: 5px;
    width: 34px;
    &.el-select-dropdown__item.hover{
      background-color: transparent;
    }
    &.el-select-dropdown__item.selected{
      color: transparent;
    }
  }



  .contentbox.private{
    background-color: #f2f2f2;
    width: 100%;

    .toptitle{
      position: fixed;
      z-index: 2;
      background-color: @maincolor;
      height: 52px;
      font-size: 16px;
      line-height: 52px;
      color: #fff;
      box-shadow: 0px 2px 5px 2px #e8e8e8;
      text-align: center;
      /*position: relative;*/
      display: flex;
      justify-content: space-between;
      width: 90%;
      padding: 0 5%;
      img{
        height: 46px;
      }
      .personalicon{
        img{
          height: 32px;
          margin-left: 10px;
        }
      }
      .return{
        font-size: 40px;
        position: initial;
        cursor: pointer;
      }
      >div{
        span{
          display: inline-block;
          cursor: pointer;
        }
      }
    }
    .PersonalCenter{
      background-color: #fff;
      height: 100vh;
      width: 100vw;
      padding-top: 30%;
      text-align: center;
      h1{
        margin: 30px auto;
        font-size: 0.5rem;
      }
      div{
        font-size: 0.3rem;
        margin-top: 30px;
      }
    }
    .pcbox{
      margin-top: 50px;
      @media (min-width: @screen-xs-max) {
        display: flex;
        justify-content: space-around;
        background-color: #fff;
        padding: 2%;
      }
      .topimgbox{
        min-height: 300px;
        @media (min-width: @screen-xs-max) {
          width: 46%;
        }
        img{
          width: 100%;
        }
      }
      .r{
        @media (min-width: @screen-xs-max) {
          width: 46%;
        }
        .numberbox{
          background-color: #fff;
          font-size: 16px;
          padding: 0.2rem;
          div{
            margin-bottom: 0.2rem;
            .attributename{
              width: 40%;
              display: inline-block;
            }
            .el-select{
              width: 56%;
              /*min-height: 28px;*/
              min-height: 28px;
              line-height: 28px;
              .el-select__tags{
                padding: 0 0 10px 0;
              }
            }
          }
          .number{
            .lf{
              .reduce,.add{
                display: inline-block;
                border-radius: 50%;
                border: 1px solid #000;
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                cursor: pointer;
              }
              .num{
                margin: 0 0.2rem;
              }
            }
            .rg{
              color: #666;
            }
          }
          .combination_attributes{
            margin-top: 10px;
            ul{
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              justify-content: flex-start;
              li{
                cursor: pointer;
                padding: 5px 10px;
                border: 1px solid #e8e8e8;
                margin-right: 15px;
                margin-bottom: 10px;
                &.active{
                  border: 1px solid #17e4e6;
                  color: #17e4e6;
                }
              }
            }
          }
        }
        .computedbox{
          /*display: flex;*/
          /*justify-content: space-between;*/
          /*align-items: center;*/
          background: #fff;
          margin-top: 0.2rem;
          padding: 0.2rem;
          height: 10px;
          overflow: hidden;
          @media (min-width: @screen-xs-max) {
            height: auto;
          }
          .clickbox{
            cursor: pointer;
          }
          >div{
            margin-bottom: 0.2rem;
            display: flex;
            align-items: center;
            /*justify-content: space-between;*/
            .attributename{
              width: 40%;
              display: inline-block;
            }
            .el-input{
              width: 20%;
            }
            .el-select{
              .el-input{
                width: 96%;
              }
            }
            p{
              width: 20%;
            }
          }
        }
      }
    }

    .meassagebox{
      margin-top: 0.2rem;
      background-color: #fff;
      padding: 0.2rem;
      display: flex;
    }
    .garnishbox{
      background-color: #fff;
      margin-top: 0.2rem;
      padding: 0 0.1rem 0.1rem 0.1rem;
      h1{
        font-size: 16px;
        padding: 0.2rem;
      }
      ul{
        width: 100%;
        overflow-x: auto;
        /*overflow-y: hidden;*/
        white-space: nowrap;
        /*display: flex;*/
        /*justify-content: flex-start;*/
        li{
          /*height: 56px;*/
          vertical-align: text-top;
          overflow: hidden;
          width:48%;
          display: inline-block;
          margin: 0.1rem 0.1rem;
          @media (min-width: @screen-xs-max) {
            width:19%;
          }
          .titlebox{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            /*align-items: center;*/
            padding: 10px;
            background-color: #f7f7f7;
            min-height: 72px;
            white-space: pre-wrap;
            p{
              /*width: 20%;*/
            }
            p.tltle{
              /*width: 46%;*/
            }
            p.selectedquantity{
              display: flex;
              justify-content: space-between;
            }
          }
          .attributebox{
            display: flex;
            align-items: center;
            transition: all .5s;
            background-color: #f7f7f7;
            padding:0 10px;
            /*border-bottom: 1px solid #706c6c;*/
            /*width: 96vw;*/
            &.give{
              padding-bottom: 10px;
            }
            .name{
              margin-bottom: 0.2rem;
            }
            >div{
              /*margin-left: 10px;*/
              min-width: 36px;
            }
          }
          .garden{
            display: inline-block;
            border-radius: 50%;
            border: 1px solid #979797;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background: #fff;
            color: #fff;
          }
          .garden.active{
            background-color: @maincolor2;
            color: #5a5a5a;
          }
          img{
            width: 100%;
            cursor: pointer;
          }
          p{
            display: flex;
            /*justify-content: space-between;*/
            margin-bottom: 0.2rem;
            align-items: center;
            white-space: initial;
            &.one{
              padding-top: 0.2rem;
              border-top: 1px solid #706c6c;
            }
            &.towbottom{
              padding-bottom: 0.2rem;
              border-bottom: 1px solid #706c6c;
            }
            div{
              width: 70%;
              /*margin-left: 0.2rem;*/
              input{
                /*background-color: #f7f7f7;*/
              }
            }
            .el-select{
              /*width: 50%;*/
              min-height: 28px;
              height: auto;
              .el-input{
                width: 100%;
              }

            }
            span{
              /*width: 60%;*/
              display: inline-block;
              .el-tag{
                white-space: nowrap;
              }
              &.formula{
                width: 20%;
              }
              &.formula2{
                width: 22%;
              }
            }
            .reduce,.add{
              display: inline-block;
              /*border-radius: 50%;*/
              /*border: 1px solid #000;*/
              font-weight: bold;
              color: #fff;
              text-align: center;
              line-height: 24px;
              font-size: 24px;
              cursor: pointer;
              width: 50px;
            }
            span.num{
              /*margin: 0 0.01rem;*/
              font-weight: bold;
              color: #fff;
              width: 34%;
              line-height: 20px;
              text-align: center;
            }
          }
          .tltle{
            display: block;
            /*margin-top: 10px;*/
          }
          .sunbox{
            align-items: center;
            justify-content: space-around;
            background-color: #000;
            height: 30px;
          }
          &.active{
            height: 100%;
          }
        }
      }
      ul.childPartsData{
        flex-direction: column;
        li{
          /*height: 56px;*/
          margin: 0.1rem 0.1rem;
          /*overflow: hidden;*/
          &.active{
            height: 100%;
          }
        }
        .titlebox{
          min-height: 72px;
          white-space: pre-wrap;
          p{
            /*width: 24%;*/
            /*text-align: right;*/
          }
          .tltle{
            /*width: 48%;*/
          }
          .productAccessoriesPrice{
            /*width: 20%;*/
            /*padding-left: 4%;*/
          }
          .productAccessoriesPrice3{
            /*width: 24%;*/
          }
        }

      }
      .onproductAccessories{
        padding: 0.2rem;
      }
    }
    .costbox{
      padding: 0.2rem;
      margin-top: 0.2rem;
      background-color: #fff;
      ul{
        li{
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          margin-top: 0.2rem;
        }
        .red{
          color: #e4e7ed;
        }
        .gray{
          color: #a6a6a6;
        }
      }
    }
    .pcbox2{
      background-color: #fff;
      @media (min-width: @screen-xs-max) {
        display: flex;
        justify-content: space-between;
        padding: 0 2% 50px 2%;
        margin-top: 0.2rem;
        >div{
          width: 46%;
        }
      }
      .l{
        .totalbox{
          margin-top: 0.2rem;
          padding: 0.5rem 0.2rem 0.2rem;
          background-color: #fff;
          display: flex;
          justify-content: space-between;
          font-size: 16px;
        }
        .remarks{
          padding: 0.2rem;
          background-color: #fff;
          textarea{
            width: 100%;
          }
        }
      }
      .r{
        .usermeassagebox{
          display: flex;
          ul{
            width: 40%;
            padding-top: 0.2rem;
            background-color: #fff;
            li{
              display: flex;
              /*justify-content: space-between;*/
              align-items: center;
              /*border-bottom: 1px solid #e8e8e8;*/
              padding: 0.2rem;
              input{
                width: 100%;
              }
              span{
                display: flex;
                justify-content: space-between;
                align-items: center;
                span{
                  font-size: 26px;
                  margin-left: 0.1rem;
                }
              }
              textarea{
                height: 40px;
                width: 100%;
                resize: none;
                &::placeholder{
                  color: #333;
                }
              }
            }
          }
          >div{
            width: 58%;
            padding-right: 2%;
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            img{
              max-width: 100%;
            }
          }
        }
        .butbox{
          background: @maincolor2;
          color: #fff;
          padding: 0.3rem 0.2rem;
          font-size: 18px;
          text-align: center;
          cursor: pointer;
        }
      }
    }

    .modebox{
      padding: 0.2rem;
      background-color: #f2f2f2;
      font-size: 16px;
      border-bottom: 1px solid #979797;
      border-top: 1px solid #979797;
      ul{
        display: flex;
        justify-content: space-between;
        li{
          .garden{
            display: inline-block;
            border-radius: 50%;
            border: 1px solid #979797;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background: #fff;
            color: transparent;
          }
        }
        .active{
          .garden{
            background: @maincolor2;
          }
        }
      }
    }
    .footerbox{
      padding: 0.3rem 0.2rem;
      background-color: #f7f7f7;
      font-size: 18px;
      color: #a6a6a6;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/touristshop.vue